import LangKeys from "./keys";

const hi = {
  [LangKeys.reminders_collect_faster]: "3 गुना तेज़ी से पेमेंट वसूलें",
  [LangKeys.reminders_total_dues]: "कुल बकाया",
  [LangKeys.reminders_all_customers]: "सभी ग्राहक",
  [LangKeys.reminders_all]: "सभी",
  [LangKeys.reminders_customers]: "ग्राहक",
  [LangKeys.reminders_suppliers]: "सप्लायर्स (व्यापारी)",
  [LangKeys.reminders_search_placeholder]: "ग्राहक का नाम या मोबाइल नंबर खोजें...",
  [LangKeys.reminders_pending_balance]: "बकाया राशि",
  [LangKeys.reminders_sent]: "भेजा गया",
  [LangKeys.reminders_whatsapp]: "WhatsApp",
  [LangKeys.reminders_sms]: "SMS",
  [LangKeys.reminders_call]: "कॉल करें",
  [LangKeys.reminders_date]: "तारीख",
  [LangKeys.reminders_all_up_to_date]: "सब अप-टू-डेट है",
  [LangKeys.reminders_no_overdue_heading]: "कोई ओवरड्यू ग्राहक नहीं मिला",
  [LangKeys.reminders_no_overdue_sub]: "बहुत बढ़िया! सभी ग्राहकों का भुगतान समय पर है और कोई बकाया ओवरड्यू नहीं है।",
  [LangKeys.reminders_view_all_customers]: "सभी ग्राहक देखें",
  [LangKeys.reminders_no_due_today_heading]: "आज कोई देय भुगतान नहीं है",
  [LangKeys.reminders_no_due_today_sub]: "आज के लिए कोई पेमेंट रिमाइंडर निर्धारित नहीं है।",
  [LangKeys.reminders_no_upcoming_heading]: "कोई आगामी रिमाइंडर नहीं है",
  [LangKeys.reminders_no_upcoming_sub]: "समय पर ऑटो रिमाइंडर भेजने के लिए ग्राहकों की कलेक्शन तारीख तय करें।",
  [LangKeys.reminders_no_customers_found]: "कोई ग्राहक नहीं मिला",
  [LangKeys.reminders_no_customers_matched]: "आपकी खोज के अनुसार कोई ग्राहक नहीं मिला।",
  [LangKeys.reminders_auto_reminder_active]: "ऑटो रिमाइंडर सक्रिय",
  [LangKeys.reminders_overdue_by]: "समय बीता",
  [LangKeys.reminders_due_in]: "देय बाकी",
  [LangKeys.reminders_days]: "दिन",
  [LangKeys.reminders_day]: "दिन",
  [LangKeys.reminders_set_collection_date]: "कलेक्शन तारीख सेट करें",
  [LangKeys.reminders_collect_faster_sub]: "ग्राहकों से तेज़ी से भुगतान प्राप्त करें",
  [LangKeys.reminders_pending_amount_filter]: "बकाया राशि फ़िल्टर (₹)",
  [LangKeys.reminders_highest_amount]: "अधिकतम राशि",
  [LangKeys.reminders_oldest_dues]: "सबसे पुरानी बकाया",
  [LangKeys.reminders_by_due_date]: "तारीख के अनुसार",
  [LangKeys.reminders_min]: "न्यूनतम",
  [LangKeys.reminders_max]: "अधिकतम",
  [LangKeys.reminders_to]: "से",
  [LangKeys.reminders_customers_selected]: "ग्राहक चुने गए",
  [LangKeys.reminders_total]: "कुल",
  [LangKeys.reminders_set_due_date_selected]: "चुने गए ग्राहकों की तारीख तय करें",
  [LangKeys.reminders_date_lbl]: "तारीख",
  [LangKeys.reminders_wa_sent_toast]: "{name} को WhatsApp रिमाइंडर भेजा गया!",
  [LangKeys.reminders_date_updated]: "रिमाइंडर तारीख सुरक्षित कर दी गई!",

  [LangKeys.reminders_bulk_success]: "सफलतापूर्वक रिमाइंडर भेज दिया गया!",

  [LangKeys.reminders_sending]: "सुरक्षित हो रहा है...",

  [LangKeys.reminders_cloud_wa]: "क्लाउड WhatsApp API (ऑटो क्रेडिट)",

  [LangKeys.reminders_direct_wa]: "सीधा WhatsApp (फ्री वेब/ऐप)",

  [LangKeys.reminders_no_pending_desc]: "जब किसी ग्राहक से पैसे लेने होंगे, तो वे यहाँ रिमाइंडर सूची में दिखाई देंगे।",

  [LangKeys.reminders_no_pending]: "कोई पेंडिंग रिमाइंडर नहीं है",

  [LangKeys.reminders_clear_date]: "तारीख हटाएं",

  [LangKeys.reminders_save_date]: "तारीख सुरक्षित करें",

  [LangKeys.reminders_time_lbl]: "समय",

  [LangKeys.reminders_chip_custom]: "कस्टम तारीख",

  [LangKeys.reminders_chip_1month]: "1 माह बाद",

  [LangKeys.reminders_chip_15days]: "15 दिन बाद",

  [LangKeys.reminders_chip_1week]: "1 सप्ताह बाद",

  [LangKeys.reminders_chip_3days]: "3 दिन बाद",

  [LangKeys.reminders_chip_tomorrow]: "कल",

  [LangKeys.reminders_chip_today]: "आज",

  [LangKeys.reminders_days_left]: "दिन शेष",

  [LangKeys.reminders_days_overdue]: "दिन लेट",

  [LangKeys.reminders_not_sent]: "अभी तक नहीं भेजा गया",

  [LangKeys.reminders_last_sent]: "अंतिम बार भेजा गया",

  [LangKeys.reminders_auto_reminder_desc]: "निर्धारित तारीख और समय पर अपने आप रिमाइंडर भेजें",

  [LangKeys.reminders_auto_reminder]: "ऑटो रिमाइंडर (Auto Send)",

  [LangKeys.reminders_send_all_whatsapp]: "एक साथ व्हाट्सएप भेजें",

  [LangKeys.reminders_send_whatsapp]: "WhatsApp रिमाइंडर भेजें",

  [LangKeys.reminders_change_due_date]: "तारीख बदलें",

  [LangKeys.reminders_set_due_date]: "देय तारीख सेट करें",

  [LangKeys.reminders_selected]: "चुने गए",

  [LangKeys.reminders_select_all]: "सभी चुनें",

  [LangKeys.reminders_search_hint]: "ग्राहक का नाम या मोबाइल नंबर खोजें...",

  [LangKeys.reminders_no_date_tab]: "बिना तारीख",

  [LangKeys.reminders_upcoming_tab]: "आगामी",

  [LangKeys.reminders_overdue_tab]: "ओवरड्यू",

  [LangKeys.reminders_today_tab]: "आज देय",

  [LangKeys.reminders_all_tab]: "सभी",

  [LangKeys.reminders_no_date]: "बिना तारीख",

  [LangKeys.reminders_upcoming]: "आगामी (Upcoming)",

  [LangKeys.reminders_due_today]: "आज देय",

  [LangKeys.reminders_overdue]: "ओवरड्यू (समय बीता)",

  [LangKeys.reminders_total_outstanding]: "कुल वसूली बाकी",

  [LangKeys.reminders_subtitle]: "स्मार्ट बहीखाता के साथ अपना व्यवसाय बढ़ाएं।",

  [LangKeys.reminders_title]: "पेमेंट रिमाइंडर",

  [LangKeys.processing]: "प्रक्रिया जारी है...",

  [LangKeys.business_owner]: "व्यापार मालिक",

  [LangKeys.moxpal_khata]: "मोक्सपाल खाता",

  [LangKeys.failed_load_dashboard]: "डैशबोर्ड डेटा लोड करने में विफल",

  [LangKeys.delete_confirm]: "क्या आप वाकई हटाना चाहते हैं?",

  [LangKeys.today]: "आज",

  [LangKeys.add_bill_terms_conditions_hint]: "नियम और शर्तें दर्ज करें...",

  [LangKeys.stock]: "स्टॉक",

  [LangKeys.add_bill_item_price]: "मूल्य / दर",

  [LangKeys.add_bill_item_name]: "आइटम का नाम",

  [LangKeys.parties]: "पार्टी",

  [LangKeys.address_area]: "इलाका / लैंडमार्क",

  [LangKeys.address_flat_no]: "मकान / दुकान नं.",

  [LangKeys.search_items_hint]: "आइटम खोजें...",

  [LangKeys.no_items_found]: "कोई आइटम नहीं मिला",

  [LangKeys.loading]: "लोड हो रहा है...",

  [LangKeys.edit_price_dialog_title]: "मूल्य बदलें",

  [LangKeys.photos]: "फ़ोटो",

  [LangKeys.notes]: "नोट्स",

  [LangKeys.save_expense]: "खर्च सहेजें",

  [LangKeys.add_bill_payment_details]: "भुगतान विवरण",

  [LangKeys.fields]: "फ़ील्ड्स",

  [LangKeys.unpaid]: "बाकी (Unpaid)",

  [LangKeys.item_name_required]: "आइटम का नाम आवश्यक है",

  [LangKeys.delete_confirmation]: "क्या आप वाकई इसे हटाना चाहते हैं?",

  [LangKeys.online_private]: "निजी (Private)",

  [LangKeys.online_active]: "ऑनलाइन मार्केट में सक्रिय",

  [LangKeys.app_name]: 'मोक्सपाल खाता',
  [LangKeys.header_subtitle]: "स्मार्ट बहीखाता के साथ अपने व्यवसाय को आगे बढ़ाएं।",

  // SHARED KHATA
  [LangKeys.shared_khata__summary]: 'खाता सारांश',
  [LangKeys.customer_name]: 'ग्राहक का नाम',
  [LangKeys.mobile_no]: 'मोबाइल नंबर',
  [LangKeys.transaction_history]: 'लेन-देन का इतिहास',
  [LangKeys.total_debit]: 'कुल डेबिट',
  [LangKeys.total_credit]: 'कुल क्रेडिट',
  [LangKeys.net_balance]: 'नेट बैलेंस',

  [LangKeys.date]: 'तारीख',
  [LangKeys.credit]: 'क्रेडिट',
  [LangKeys.debit]: 'डेबिट',
  [LangKeys.balance]: 'बैलेंस',
  [LangKeys.note]: 'नोट',

  [LangKeys.call_support]: 'सहायता के लिए कॉल करें',
  [LangKeys.invalid_link]: 'यह लिंक अमान्य है या समाप्त हो गया है।',
  [LangKeys.footer]: 'यह एक कंप्यूटर जनित विवरण है और इसके लिए किसी हस्ताक्षर की आवश्यकता नहीं है।',

  // COMMON
  [LangKeys.settings]: 'सेटिंग्स',
  [LangKeys.settings_subtitle]: 'अपने एप्लिकेशन और व्यावसायिक प्राथमिकताएं प्रबंधित करें',

  [LangKeys.language]: 'भाषा',
  [LangKeys.select_language]: 'भाषा चुनें',
  [LangKeys.close]: 'बंद करें',
  [LangKeys.save]: 'सहेजें',
  [LangKeys.retry]: 'पुनः प्रयास करें',
  [LangKeys.profile]: 'प्रोफाइल एडिट करें',
  [LangKeys.logout]: 'लॉगआउट',

  [LangKeys.version]: 'संस्करण',
  [LangKeys.copyright]: 'कॉपीराइट © मोक्षपाल खाता',

  [LangKeys.total]: "कुल",
  [LangKeys.required_field]: "यह फ़ील्ड आवश्यक है",
  [LangKeys.product]: "उत्पाद",

  [LangKeys.message_language]: "SMS भाषा",
  [LangKeys.follow_app]: "ऐप के अनुसार",

  [LangKeys.hindi]: "हिंदी",
  [LangKeys.english]: "अंग्रेज़ी",
  [LangKeys.hinglish]: "हिंग्लिश",

  [LangKeys.gujarati]: "गुजराती",
  [LangKeys.marathi]: "मराठी",
  [LangKeys.punjabi]: "पंजाबी",
  [LangKeys.tamil]: "तमिल",
  [LangKeys.telugu]: "तेलुगु",

  // SETTINGS PAGE
  [LangKeys.business_settings]: 'व्यापार सेटिंग्स',
  [LangKeys.business_settings_desc]: 'व्यापार प्रोफ़ाइल, लोगो और GST विवरण',

  [LangKeys.staff_permissions]: 'कर्मचारी और अनुमतियाँ',
  [LangKeys.staff_permissions_desc]: 'कर्मचारी पहुंच और अनुमतियों का प्रबंधन करें',

  [LangKeys.backup_information]: 'बैकअप जानकारी',
  [LangKeys.backup_information_desc]: 'खाता डेटा निर्यात और पुनर्स्थापित करें',

  [LangKeys.delete_khata]: 'खाता हटाएं',
  [LangKeys.delete_khata_desc]: 'सभी व्यावसायिक डेटा स्थायी रूप से हटाएं',

  [LangKeys.app_update]: 'ऐप अपडेट',
  [LangKeys.app_update_desc]: 'नवीनतम संस्करण के लिए जांचें',

  [LangKeys.app_up_to_date]: "ऐप नवीनतम है",
  [LangKeys.failed_to_check_for_update]: "अपडेट जांचने में विफल",

  [LangKeys.whatsapp_service]: "व्हाट्सएप अलर्ट और क्रेडिट",
  [LangKeys.whatsapp_service_desc]: "ग्राहकों को ऑटो पेमेंट रिमाइंडर भेजें और बैलेंस मैनेज करें",

  // Whatsapp SMS Credits PAGE
  [LangKeys.whatsapp_credits]: 'व्हाट्सएप क्रेडिट्स',
  [LangKeys.available_credits]: 'उपलब्ध क्रेडिट्स',
  [LangKeys.whatsapp_balance]: 'व्हाट्सएप संदेश बैलेंस',
  [LangKeys.used]: 'उपयोग',
  [LangKeys.credits]: 'क्रेडिट्स',
  [LangKeys.proceed_to_pay]: 'पेमेंट करें',
  [LangKeys.recharge_plans]: 'रिचार्ज प्लान',
  [LangKeys.off]: 'बंद',
  [LangKeys.premium_unlimited_active]: "असीमित व्हाट्सएप अलर्ट सक्रिय हैं! 🎉",
  [LangKeys.premium_unlimited_desc]: "आप Moxpal Khata के सर्वोत्तम प्लान 'Premium Plan 98' के सक्रिय सदस्य हैं! आपको असीमित ऑटो व्हाट्सएप और एसएमएस अलर्ट्स बिल्कुल मुफ्त दिए गए हैं।",

  [LangKeys.load_failed]: 'लोड फेल हुआ',
  [LangKeys.toggle_failed]: 'टॉगल फेल हुआ',
  [LangKeys.order_failed]: 'ऑर्डर फेल हुआ',
  [LangKeys.payment_error]: 'पेमेंट एरर',
  [LangKeys.payment_failed]: 'पेमेंट फेल हुआ',
  [LangKeys.verification_failed]: 'वेरिफिकेशन फेल हुआ',
  [LangKeys.recharge_successful]: 'रिचार्ज सफल हुआ',
  [LangKeys.total_purchased]: 'कुल खरीदे गए',

  // BACKUP INFORMATION
  [LangKeys.backup_info_text]: 'जब आपका फोन इंटरनेट से जुड़ा होता है तब आपका डेटा अपने आप बैकअप हो जाता है। यदि आप फोन फॉर्मेट कर दें या ऐप हटा दें, तो अपने रजिस्टर्ड नंबर से लॉगिन करें। आपका पूरा डेटा अपने आप वापस आ जाएगा।',
  [LangKeys.last_backup_at]: 'अंतिम बैकअप समय',

  // DELETE / KHATA
  [LangKeys.delete_warning_text]: 'आप अपना खाता हटाने जा रहे हैं। आपका सारा डेटा रीसायकल बिन में चला जाएगा। 30 दिनों के भीतर इसे वापस किया जा सकता है।',
  [LangKeys.delete_placeholder]: 'पुष्टि करने के लिए बिज़नेस नाम लिखें',
  [LangKeys.delete_button]: 'डिलीट',
  [LangKeys.delete_name_mismatch]: 'बिज़नेस नाम सही नहीं है',

  // KHATA
  [LangKeys.my_khata]: "मेरा खाता",
  [LangKeys.search_customer]: "ग्राहक खोजें",
  [LangKeys.all_customers]: "सभी ग्राहक",
  [LangKeys.no_customers_found]: "कोई ग्राहक नहीं मिला",
  [LangKeys.no_suppliers_found]: "कोई सप्लायर नहीं मिला",
  [LangKeys.no_parties_found]: "कोई पार्टी नहीं मिला",

  [LangKeys.just_now]: 'अभी अभी',
  [LangKeys.min_ago]: '{value} मिनट पहले',
  [LangKeys.hr_ago]: '{value} घंटे पहले',
  [LangKeys.day_ago]: '{value} दिन पहले',
  [LangKeys.month_ago]: '{value} महीने पहले',
  [LangKeys.year_ago]: '{value} साल पहले',

  [LangKeys.settled]: 'हिसाब बराबर',
  [LangKeys.advance]: 'जमा राशि',
  [LangKeys.due]: 'उधार',
  [LangKeys.no_transactions]: 'कोई लेन-देन नहीं',
  [LangKeys.no_entries_yet]: 'कोई एंट्री नहीं',
  [LangKeys.new_label]: 'नया',

  // DASHBOARD / HOME SCREEN
  [LangKeys.khata]: 'खाता',
  [LangKeys.you_will_get]: 'आपको मिला',
  [LangKeys.you_will_give]: 'आपने दिया',
  [LangKeys.search_khata_entry]: 'खाता एंट्री खोजें',
  [LangKeys.recent_entries]: 'हाल की प्रविष्टियाँ',
  [LangKeys.unknown_party]: 'अज्ञात पार्टी',
  [LangKeys.unknown_customer]: 'अज्ञात ग्राहक',
  [LangKeys.unknown]: 'अज्ञात',

  // CUSTOMER LEDGER
  [LangKeys.ledger]: 'लेजर',
  [LangKeys.report]: 'रिपोर्ट',
  [LangKeys.reminder]: 'रिमाइंडर',
  [LangKeys.sms]: 'एसएमएस',
  [LangKeys.whatsapp]: 'व्हाट्सऐप',
  [LangKeys.outstanding_balance]: "कुल बकाया",

  [LangKeys.total_balance]: 'कुल बकाया',
  [LangKeys.you_got]: 'आपको मिला',
  [LangKeys.you_gave]: 'आपने दिया',

  [LangKeys.entries]: 'प्रविष्टियाँ',
  [LangKeys.no_entries_found]: 'कोई प्रविष्टि नहीं मिली',

  [LangKeys.i_got]: 'मुझे मिला',
  [LangKeys.i_gave]: 'मैंने दिया',

  [LangKeys.you_got_caps]: 'आपको मिला',
  [LangKeys.you_gave_caps]: 'आपने दिया',

  [LangKeys.wa_dear]: 'प्रिय',
  [LangKeys.wa_account_update]: 'आपके खाते की जानकारी अपडेट की गई है।',
  [LangKeys.total_due]: 'कुल बकाया राशि',
  [LangKeys.view_full_account]: 'पूरा खाता विवरण यहां देखें',
  [LangKeys.failed_to_load_data]: 'डेटा लोड करने में विफल।',
  [LangKeys.could_not_open_whatsapp]: 'व्हाट्सएप नहीं खुल सका।',
  [LangKeys.could_not_open_sms]: 'एसएमएस ऐप नहीं खुल सका।',
  [LangKeys.total_purchase]: "कुल खरीद",
  [LangKeys.total_received]: "कुल प्राप्त",

  [LangKeys.entry_success]: 'एंट्री सफल हुई',
  [LangKeys.transaction_success]: 'लेन-देन सफल हुआ',
  [LangKeys.done]: 'पूरा हुआ',

  // ENTRY
  [LangKeys.entry_details]: 'प्रविष्टि विवरण',
  [LangKeys.running_balance]: 'चालू शेष',
  [LangKeys.share]: 'साझा करें',
  [LangKeys.network_error]: 'नेटवर्क त्रुटि',
  [LangKeys.copy_link]: 'लिंक कॉपी करें',

  [LangKeys.delete_entry]: 'प्रविष्टि हटाएं',
  [LangKeys.delete_entry_confirm]: 'क्या आप वाकई इस प्रविष्टि को हटाना चाहते हैं?',
  [LangKeys.delete_entry_warning]: 'यह क्रिया पूर्ववत नहीं की जा सकती।',

  [LangKeys.edit_entry]: 'प्रविष्टि संपादित करें',
  [LangKeys.update_entry]: 'अपडेट करें',
  [LangKeys.invalid_entry]: 'अमान्य प्रविष्टि',
  [LangKeys.entry_not_found]: 'प्रविष्टि नहीं मिली',
  [LangKeys.invalid_entry_type]: 'अमान्य प्रविष्टि प्रकार',
  [LangKeys.invalid_amount]: 'अमान्य राशि',
  [LangKeys.invalid_date]: 'अमान्य तारीख',
  [LangKeys.photo_size_error]: 'फोटो का आकार 1MB से कम होना चाहिए',
  [LangKeys.invalid_image_format]: 'यह फोटो फॉर्मेट सपोर्ट नहीं है। कृपया JPG, PNG या WEBP फोटो चुनें।',
  [LangKeys.photo_upload_failed]: 'फोटो अपलोड विफल',
  [LangKeys.update_failed]: 'अपडेट विफल',

  [LangKeys.amount]: 'राशि',
  [LangKeys.photo_max]: 'फोटो (अधिकतम 1MB)',
  [LangKeys.change_photo]: 'फोटो बदलें',
  [LangKeys.add_entry_title]: 'प्रविष्टि जोड़ें',
  [LangKeys.save_entry]: 'प्रविष्टि सहेजें',
  [LangKeys.photo]: 'फोटो',
  [LangKeys.amount_hint]: '₹ 0',
  [LangKeys.note_hint]: 'वैकल्पिक नोट',
  [LangKeys.add_photo_label]: '📷 फोटो जोड़ें',
  [LangKeys.failed_to_add_entry]: 'प्रविष्टि जोड़ने में विफल।',
  [LangKeys.image_too_large_4mb]: 'छवि बहुत बड़ी है। कृपया 4MB से कम की छवि चुनें।',
  [LangKeys.share_coming_soon]: 'साझा सुविधा जल्द ही आ रही है!',
  [LangKeys.image_load_failed]: 'छवि लोड करने में विफल',
  [LangKeys.select_date]: 'तारीख चुनें',
  [LangKeys.photo_max_2mb]: 'फोटो साइज (अधिकतम 2 MB)',
  [LangKeys.add_to_cashbook]: 'कैशबुक में भी जोड़ें',

  // PDF
  [LangKeys.owner_name]: 'मालिक का नाम',
  [LangKeys.customer_ledger_statement]: 'ग्राहक लेजर स्टेटमेंट',
  [LangKeys.phone]: 'फ़ोन',
  [LangKeys.opening_balance]: 'प्रारंभिक शेष',
  [LangKeys.closing_balance]: 'अंतिम शेष',

  [LangKeys.transaction_details]: 'लेन-देन विवरण',
  [LangKeys.particulars]: 'विवरण',

  [LangKeys.credit_short]: 'क्रेडिट',
  [LangKeys.debit_short]: 'डेबिट',
  [LangKeys.data_not_available_for_pdf]: "PDF के लिए डेटा उपलब्ध नहीं है",

  [LangKeys.generated_by]: 'मोक्सपाल खाता द्वारा उत्पन्न',
  [LangKeys.my_business]: 'मेरा व्यवसाय',
  [LangKeys.pdf_generation_error]: 'पीडीएफ बनाने में त्रुटि',
  [LangKeys.debit_minus]: 'डेबिट (-)',
  [LangKeys.credit_plus]: 'क्रेडिट (+)',
  [LangKeys.total_paid]: "कुल भुगतान",
  [LangKeys.received]: 'प्राप्त',
  [LangKeys.paid]: "भुगतान",
  [LangKeys.supplier_name]: "सप्लायर का नाम",
  [LangKeys.supplier_report]: "सप्लायर रिपोर्ट",
  [LangKeys.supplier_ledger_statement]: "सप्लायर लेजर विवरण",
  [LangKeys.customer_report]: "ग्राहक रिपोर्ट",
  [LangKeys.print_download]: "प्रिंट / डाउनलोड",
  [LangKeys.total_get]: "कुल प्राप्त",
  [LangKeys.total_give]: "कुल भुगतान",
  [LangKeys.report_for]: "के लिए रिपोर्ट",
  [LangKeys.period]: "अवधि",
  [LangKeys.report_generated_by]: "{app} द्वारा जनरेट की गई रिपोर्ट",
  [LangKeys.all_time]: "कुल समय",
  [LangKeys.get]: "प्राप्त",
  [LangKeys.give]: "दिया",

  // ACCOUNT
  [LangKeys.account]: 'अकाउंट',
  [LangKeys.add_business]: 'व्यापार विवरण जोड़ें',
  [LangKeys.add_owner]: 'मालिक विवरण जोड़ें',

  [LangKeys.business]: 'व्यापार',
  [LangKeys.staff]: 'कर्मचारी',
  [LangKeys.items]: 'आइटम',
  [LangKeys.bills]: 'बिल',
  [LangKeys.dairy]: "डेयरी",
  [LangKeys.cashbook]: 'कैशबुक',

  [LangKeys.help_support]: 'सहायता और समर्थन',
  [LangKeys.about_app]: 'हमारे बारे में',
  [LangKeys.invite_friends]: 'दोस्तों को आमंत्रित करें',
  [LangKeys.privacy_policy]: 'गोपनीयता नीति',
  [LangKeys.disclaimer]: 'अस्वीकरण',
  [LangKeys.share_subject]: "📒 मोक्षपाल खाता ऐप",
  [LangKeys.share_message]: "👉 उधार-लेनदेन और हिसाब रखने के लिए मैं मोक्षपाल खाता ऐप इस्तेमाल कर रहा हूँ। यह बहुत आसान और भरोसेमंद ऐप है। 📲 आप भी अभी डाउनलोड करें और अपने खातों का रिकॉर्ड आसानी से मैनेज करें: https://khata.moxpal.com/app",

  // STAFF
  [LangKeys.staff_details]: 'कर्मचारी विवरण',
  [LangKeys.staff_question]: 'एक कर्मचारी क्या है?',
  [LangKeys.add_staff]: 'कर्मचारी जोड़ें',
  [LangKeys.staff_name]: 'कर्मचारी का नाम',
  [LangKeys.permissions]: 'अनुमतियाँ',
  [LangKeys.stop_staff]: 'कर्मचारी रोकें',
  [LangKeys.stop_staff_desc]: 'यह कर्मचारी आपके व्यापार डेटा तक नहीं पहुंच पाएगा।',
  [LangKeys.delete_staff]: 'कर्मचारी हटाएं',
  [LangKeys.delete_staff_desc]: 'यह कर्मचारी स्थायी रूप से हटा दिया जाएगा।',
  [LangKeys.add_staff_to_manage]: "मैनेज करने के लिए स्टाफ जोड़ें",

  // NAVBAR
  [LangKeys.home]: 'होम',
  [LangKeys.more]: "और",

  // ADD PARTY
  [LangKeys.add_party]: 'पार्टी जोड़ें',
  [LangKeys.address_optional]: 'पता (वैकल्पिक)',
  [LangKeys.gst_optional]: 'जीएसटीआईएन (वैकल्पिक)',
  [LangKeys.add_supplier]: 'सप्लायर जोड़ें',
  [LangKeys.name_required]: 'नाम आवश्यक है',
  [LangKeys.edit]: 'संपादित करें',

  // BOOK PROFILE
  [LangKeys.book_profile]: 'खाता प्रोफाइल बनाएं',
  [LangKeys.personal_info]: 'व्यक्तिगत जानकारी',
  [LangKeys.business_info]: 'व्यापार जानकारी',
  [LangKeys.financial_info]: 'वित्तीय जानकारी',
  [LangKeys.staff_info]: 'कर्मचारी जानकारी',

  [LangKeys.name]: 'नाम',
  [LangKeys.add_name]: 'नाम जोड़ें',
  [LangKeys.registered_number]: 'पंजीकृत मोबाइल नंबर',
  [LangKeys.add_mobile]: 'मोबाइल नंबर जोड़ें',

  [LangKeys.business_name]: 'व्यापार का नाम',
  [LangKeys.business_address]: 'व्यापार का पता',
  [LangKeys.add_address]: 'पता जोड़ें',

  [LangKeys.gstin]: 'जीएसटीआईएन',
  [LangKeys.bank_account]: 'बैंक खाता',
  [LangKeys.add_details]: 'विवरण जोड़ें',
  [LangKeys.details]: 'विवरण',
  [LangKeys.add_photo]: "फोटो जोड़ें",
  [LangKeys.profile_strength]: "प्रोफाइल की मजबूती",
  [LangKeys.customer_profile]: "ग्राहक प्रोफाइल",
  [LangKeys.supplier_profile]: "सप्लायर प्रोफाइल",
  [LangKeys.address]: "पता",
  [LangKeys.type]: "प्रकार",
  [LangKeys.customer]: "ग्राहक",
  [LangKeys.supplier]: "सप्लायर",
  [LangKeys.delete_customer]: "ग्राहक हटाएं",
  [LangKeys.delete_supplier]: "सप्लायर हटाएं",
  [LangKeys.delete_customer_desc]: "क्या आप इस ग्राहक को हटाना चाहते हैं? इससे जुड़ा सारा डेटा हट जाएगा।",
  [LangKeys.delete_supplier_desc]: "क्या आप इस सप्लायर को हटाना चाहते हैं? इससे जुड़ा सारा डेटा हट जाएगा।",
  [LangKeys.add_gstin]: "GSTIN जोड़ें",

  // SMS SETTINGS
  [LangKeys.sms_settings]: "SMS सेटिंग्स",
  [LangKeys.sms_settings_desc]: "इस ग्राहक के लिए मैसेज सेटिंग्स मैनेज करें",

  [LangKeys.edit_customer_details]: "ग्राहक विवरण संपादित करें",
  [LangKeys.edit_customer_details_desc]: "आप यहाँ नाम, मोबाइल, पता और GST जैसी जानकारी बदल सकते हैं।",

  // PROFILE STRENGTH
  [LangKeys.weak]: 'कमजोर',
  [LangKeys.average]: 'औसत',
  [LangKeys.good]: 'अच्छा',
  [LangKeys.strong]: 'मजबूत',

  // STAFF & PERMISSIONS
  [LangKeys.save_staff]: 'कर्मचारी सहेजें',
  [LangKeys.update_staff]: 'कर्मचारी अपडेट करें',
  [LangKeys.cancel]: 'रद्द करें',

  [LangKeys.no_staff_found]: 'कोई कर्मचारी नहीं मिला',

  [LangKeys.active]: 'सक्रिय',
  [LangKeys.stopped]: 'रोका गया',
  [LangKeys.start]: 'शुरू करें',
  [LangKeys.stop]: 'रोकें',

  [LangKeys.view]: 'देखें',
  [LangKeys.add]: 'जोड़ें',
  [LangKeys.delete]: 'हटाएं',

  [LangKeys.mobile_number]: 'मोबाइल नंबर',
  [LangKeys.add_staff_title]: 'कर्मचारी जोड़ें',
  [LangKeys.edit_staff_title]: 'कर्मचारी संपादित करें',

  [LangKeys.staff_deleted_success]: 'कर्मचारी सफलतापूर्वक हटा दिया गया',

  [LangKeys.yes]: 'हाँ',
  [LangKeys.no]: 'नहीं',

  [LangKeys.khatabook_deleted_success]: 'खाता बुक सफलतापूर्वक हटा दी गई',
  [LangKeys.something_went_wrong]: 'कुछ गलत हो गया',

  // Business Logo
  [LangKeys.business_logo]: 'व्यापार लोगो',
  [LangKeys.choose_photo]: 'फोटो चुनें',
  [LangKeys.save_logo]: 'लोगो सहेजें',
  [LangKeys.upload_error]: 'अपलोड त्रुटि',
  [LangKeys.upload_type_err]: 'अपलोड प्रकार त्रुटि',

  // Edit Field
  [LangKeys.enter_name]: 'नाम दर्ज करें',
  [LangKeys.enter_mobile]: 'मोबाइल दर्ज करें',
  [LangKeys.enter_business]: 'व्यापार दर्ज करें',
  [LangKeys.enter_address]: 'पता दर्ज करें',

  // GSTIN
  [LangKeys.gstin_details]: 'जीएसटीआईएन विवरण',
  [LangKeys.gstin_number]: 'जीएसटीआईएन नंबर',
  [LangKeys.enter_gstin]: 'जीएसटीआईएन दर्ज करें',
  [LangKeys.gstin_note]: 'आपका जीएसटीआईएन आपके व्यापार को सत्यापित करने और चालान बनाने के लिए उपयोग किया जाता है।',
  [LangKeys.save_gstin]: 'जीएसटीआईएन सहेजें',

  // BANK
  [LangKeys.bank_details]: 'बैंक विवरण',
  [LangKeys.bank_name]: 'बैंक का नाम',
  [LangKeys.enter_bank_name]: 'बैंक का नाम दर्ज करें',
  [LangKeys.account_number]: 'खाता संख्या',
  [LangKeys.enter_account_no]: 'खाता संख्या दर्ज करें',
  [LangKeys.ifsc_code]: 'आईएफएससी कोड',
  [LangKeys.enter_ifsc]: 'आईएफएससी कोड दर्ज करें',
  [LangKeys.bank_note]: 'आपका बैंक खाता भुगतान प्राप्त करने के लिए उपयोग किया जाता है।',
  [LangKeys.save_bank_details]: 'बैंक विवरण सहेजें',
  [LangKeys.invalid_bank_details]: 'अमान्य बैंक विवरण',

  // STAFF
  [LangKeys.confirm]: 'पुष्टि करें',

  // ERROR / COMMON
  [LangKeys.invalid_gstin]: 'अमान्य जीएसटीआईएन',
  [LangKeys.failed_to_save]: 'सहेजने में विफल',

  // Cashbook
  [LangKeys.cash]: "नकद",
  [LangKeys.online]: "ऑनलाइन",
  [LangKeys.total_balance_cashbook]: "कुल शेष",
  [LangKeys.today_balance]: "आज का शेष",
  [LangKeys.view_report]: "रिपोर्ट देखें",
  [LangKeys.out_entry]: "निकासी",
  [LangKeys.in_entry]: "जमा",
  [LangKeys.add_first_entry]: "अपनी पहली प्रविष्टि जोड़ें",
  [LangKeys.attach_bill]: "बिल संलग्न करें",
  [LangKeys.enter_amount]: "राशि दर्ज करें",
  [LangKeys.empty_title]: "अभी तक कोई प्रविष्टि नहीं है",
  [LangKeys.saving]: "सहेजा जा रहा है...",
  [LangKeys.save_failed]: "सहेजने में विफल",
  [LangKeys.server_error]: "सर्वर त्रुटि",
  [LangKeys.ok]: "ठीक है",
  [LangKeys.error]: "त्रुटि",
  [LangKeys.payment_mode]: "भुगतान मोड",
  [LangKeys.entry_saved_offline_and_will_be_synced_later]: "एंट्री ऑफलाइन सेव हो गई है, इंटरनेट मिलने पर सिंक हो जाएगी",
  [LangKeys.entry_waiting_to_be_synced]: "एंट्री ऑफलाइन सेव है, सिंक बाकी है",
  [LangKeys.cash_entry]: 'कैश एंट्री',
  [LangKeys.cash_in]: 'जमा किया गया',
  [LangKeys.cash_out]: 'निकासी की गई',
  [LangKeys.cashbook_status]: 'कैशबुक स्टेटस',
  [LangKeys.real_time_cash_online]: 'रियल-टाइम कैश और ऑनलाइन',

  // Cashbook Specific
  [LangKeys.entry_is_backed_up]: "प्रविष्टि का बैकअप लिया गया है",
  [LangKeys.safe_and_secure]: "100% सुरक्षित और संरक्षित",
  [LangKeys.invalid_image_format_cashbook_popup]: "असमर्थित प्रारूप। कृपया JPG, PNG, या WEBP का उपयोग करें।",
  [LangKeys.photo_size_error_cashbook_popup]: "फ़ाइल बहुत बड़ी है (अधिकतम 4MB)",
  [LangKeys.selected_image]: "चयनित",

  // Cashbook Report Screen
  [LangKeys.cashbook_report_title]: "कैशबुक रिपोर्ट",
  [LangKeys.date_range]: "तारीख सीमा",
  [LangKeys.single_day]: "एकल दिन",
  [LangKeys.this_week]: "यह सप्ताह",
  [LangKeys.this_month]: "यह महीना",
  [LangKeys.last_week]: "पिछला सप्ताह",
  [LangKeys.last_month]: "पिछला महीना",
  [LangKeys.all]: "सभी",
  [LangKeys.to]: "से",
  [LangKeys.no_entries_found_period]: "इस अवधि में कोई प्रविष्टि नहीं मिली।",
  [LangKeys.daily_balance_short]: "दैनिक शेष",
  [LangKeys.download_pdf]: "पीडीएफ डाउनलोड करें",
  [LangKeys.pdf_download_not_implemented]: "पीडीएफ डाउनलोड अभी लागू नहीं किया गया है।",

  // Cashbook Report Day Screen
  [LangKeys.daily_details]: "दैनिक विवरण",
  [LangKeys.no_entries_on_this_day]: "इस दिन कोई प्रविष्टि नहीं है",
  [LangKeys.add_entries_help]: "उन्हें यहाँ देखने के लिए प्रविष्टियाँ जोड़ें।",
  [LangKeys.add_entry_to]: "में प्रविष्टि जोड़ें",
  [LangKeys.add_entry]: "प्रविष्टि जोड़ें",
  [LangKeys.could_not_load_report]: "रिपोर्ट लोड नहीं हो सकी।",

  // Entry Details Screen
  [LangKeys.delete_failed]: "हटाने में विफल",
  [LangKeys.photo_max_4mb]: "फोटो (अधिकतम 4MB)",
  [LangKeys.entry_of_amount]: "की प्रविष्टि",

  // PDF CASHBOOK REPORT
  [LangKeys.daily_summary]: "दैनिक सारांश",
  [LangKeys.total_in]: "कुल प्राप्त",
  [LangKeys.total_out]: "कुल भुगतान",
  [LangKeys.no_data_available]: "कोई डेटा उपलब्ध नहीं है",

  // Months
  [LangKeys.month_1]: "Jan",
  [LangKeys.month_2]: "Feb",
  [LangKeys.month_3]: "Mar",
  [LangKeys.month_4]: "Apr",
  [LangKeys.month_5]: "May",
  [LangKeys.month_6]: "Jun",
  [LangKeys.month_7]: "Jul",
  [LangKeys.month_8]: "Aug",
  [LangKeys.month_9]: "Sep",
  [LangKeys.month_10]: "Oct",
  [LangKeys.month_11]: "Nov",
  [LangKeys.month_12]: "Dec",

  // Customer Supplier Add
  [LangKeys.add_customer]: "ग्राहक जोड़ें",
  [LangKeys.customer_already_exists]: 'ग्राहक पहले से मौजूद है',
  [LangKeys.supplier_already_exists]: 'सप्लायर पहले से मौजूद है',

  // CASHBOOK EMPTY STATE
  [LangKeys.cashbook_welcome]: "नमस्ते! चलिए आज की एंट्रीज़ बनाते हैं",
  [LangKeys.add_first_entry_btn]: "अपनी पहली एंट्री जोड़ें",
  [LangKeys.add_customers_collect_faster]: "ग्राहकों को जोड़ें और भुगतान तेजी से प्राप्त करें",

  // PERMISSIONS
  [LangKeys.permission_denied_title]: "अनुमति नहीं दी गई",
  [LangKeys.permission_denied_content]: "फोटो एक्सेस स्थायी रूप से अस्वीकार कर दिया गया है। कृपया इसे सक्षम करने के लिए ऐप सेटिंग्स पर जाएं।",
  [LangKeys.permission_denied_settings_button]: "सेटिंग्स खोलें",
  [LangKeys.permission_denied_cancel_button]: "रद्द करें",
  [LangKeys.permission_denied_generic_message]: "अनुमति नहीं दी गई। कृपया फोटो चुनने के लिए फोटो एक्सेस की अनुमति दें।",

  // Contact Picker
  [LangKeys.permission_required]: "अनुमति आवश्यक है",
  [LangKeys.contacts_permission_message]: "संपर्क चुनने के लिए संपर्क अनुमति आवश्यक है। कृपया इसे ऐप सेटिंग्स में सक्षम करें।",
  [LangKeys.failed_to_open_contacts_picker]: "संपर्क पिकर खोलने में विफल।",
  [LangKeys.permission_denied_to_read_contacts]: "संपर्क पढ़ने की अनुमति अस्वीकृत।",

  // Add Item Screen
  [LangKeys.tax_exempted]: "टैक्स मुक्त",
  [LangKeys.no_gst]: "GST नहीं लगेगा",
  [LangKeys.select_photo]: "फोटो चुनें",
  [LangKeys.gallery]: "गैलरी",
  [LangKeys.camera]: "कैमरा",
  [LangKeys.please_enter_item_name]: "कृपया आइटम का नाम दर्ज करें",
  [LangKeys.failed_to_upload_image]: "इमेज अपलोड नहीं हो सकी",
  [LangKeys.item_updated_successfully]: "आइटम सफलतापूर्वक अपडेट हो गया",
  [LangKeys.item_saved_successfully]: "आइटम सफलतापूर्वक सेव हो गया",
  [LangKeys.failed_to_update_item]: "आइटम अपडेट नहीं हो सका",
  [LangKeys.failed_to_save_item]: "आइटम सेव नहीं हो सका",
  [LangKeys.confirm_deletion]: "डिलीट की पुष्टि",
  [LangKeys.are_you_sure_delete_item]: "क्या आप इस आइटम को डिलीट करना चाहते हैं?",
  [LangKeys.item_deleted_successfully]: "आइटम सफलतापूर्वक डिलीट हो गया",
  [LangKeys.failed_to_delete_item]: "आइटम डिलीट नहीं हो सका",
  [LangKeys.edit_item]: "आइटम एडिट करें",
  [LangKeys.edit_service]: "सर्विस एडिट करें",
  [LangKeys.add_product]: "प्रोडक्ट जोड़ें",
  [LangKeys.add_service]: "सर्विस जोड़ें",
  [LangKeys.add_hsn_and_gst_details]: "HSN और GST की जानकारी जोड़ें",
  [LangKeys.hsn]: "HSN",
  [LangKeys.enter_hsn]: "HSN दर्ज करें",
  [LangKeys.gst_rate_percent]: "GST दर (%)",
  [LangKeys.enter_gst_rate]: "GST दर दर्ज करें",
  [LangKeys.primary_unit]: "प्राथमिक यूनिट",
  [LangKeys.enter_item_name_here]: "यहाँ आइटम का नाम लिखें",
  [LangKeys.sale_price]: "बिक्री मूल्य",
  [LangKeys.purchase_price]: "खरीद मूल्य",
  [LangKeys.tax_included]: "टैक्स शामिल है",
  [LangKeys.opening_stock]: "ओपनिंग स्टॉक",
  [LangKeys.low_stock_alert]: "लो स्टॉक अलर्ट",
  [LangKeys.as_of_date]: "तिथि तक",
  [LangKeys.enter_price]: "कीमत दर्ज करें",
  [LangKeys.enter_count]: "संख्या दर्ज करें",
  [LangKeys.save_item]: "आइटम सेव करें",
  [LangKeys.delete_item]: "आइटम डिलीट करें",
  [LangKeys.select_unit]: "यूनिट चुनें",
  [LangKeys.search_unit]: "यूनिट खोजें",
  [LangKeys.add_gst_rate]: "GST दर जोड़ें",
  [LangKeys.add_custom_tax]: "कस्टम टैक्स जोड़ें",
  [LangKeys.custom_tax]: "कस्टम टैक्स",
  [LangKeys.gst]: "GST",
  [LangKeys.cess]: "सेस",
  [LangKeys.add_hsn_code]: "HSN कोड जोड़ें",
  [LangKeys.hsn_code]: "HSN कोड",
  [LangKeys.item_name]: "आइटम का नाम",
  [LangKeys.enter_hsn_code]: "HSN कोड दर्ज करें",
  [LangKeys.enter_item_name]: "आइटम का नाम दर्ज करें",
  [LangKeys.results]: "परिणाम",
  [LangKeys.no_hsn_code_found]: "कोई HSN कोड नहीं मिला",
  [LangKeys.use]: "उपयोग करें",
  [LangKeys.as_hsn_code]: "HSN कोड के रूप में",
  [LangKeys.you_are_offline_please_connect_to_the_internet]: "आप ऑफलाइन हैं। कृपया इंटरनेट से कनेक्ट करें।",

  // ITEMS SCREEN
  [LangKeys.products]: "प्रोडक्ट्स",
  [LangKeys.services]: "सेवाएं",
  [LangKeys.add_product_caps]: "प्रोडक्ट जोड़ें",
  [LangKeys.add_service_caps]: "सेवा जोड़ें",

  [LangKeys.add_items_and_get_started]: "अपनी इन्वेंटरी प्रबंधन शुरू करें",
  [LangKeys.manage_stock_feature]: "अपने व्यवसाय के लिए स्मार्ट स्टॉक नियंत्रण",
  [LangKeys.detailed_stock_history_feature]: "आइटम गतिविधियों का पूरा रिकॉर्ड देखें",
  [LangKeys.track_prices_and_profits_feature]: "कीमत और लाभ मार्जिन को आसानी से मॉनिटर करें",

  [LangKeys.search_items]: "आइटम खोजें",
  [LangKeys.my_items]: "मेरे आइटम",
  [LangKeys.item_added]: "आइटम जोड़ा गया",
  [LangKeys.low_stock]: "कम स्टॉक",
  [LangKeys.current_stock]: "वर्तमान स्टॉक",
  [LangKeys.stock_history]: "स्टॉक इतिहास",
  [LangKeys.stock_in]: "स्टॉक इन",
  [LangKeys.stock_out]: "स्टॉक आउट",
  [LangKeys.add_services_and_get_started]: "अपनी सेवाओं का प्रबंधन शुरू करें",
  [LangKeys.manage_services_feature]: "अपनी सभी सेवा ऑफरिंग्स को व्यवस्थित और प्रबंधित करें",
  [LangKeys.save_sac_and_gst_feature]: "SAC कोड और GST विवरण आसानी से सहेजें",
  [LangKeys.track_sales_and_bills_feature]: "सेवा बिक्री और बिलिंग रिकॉर्ड को ट्रैक करें",

  [LangKeys.net_monthly_sales]: "कुल मासिक बिक्री",
  [LangKeys.rupees]: "रुपये",
  [LangKeys.search_services]: "सेवाएं खोजें",
  [LangKeys.my_services]: "मेरी सेवाएं",
  [LangKeys.service_price]: "सेवा मूल्य",
  [LangKeys.unit]: "इकाई",
  [LangKeys.enter_purchased_quantity]: "खरीदी गई मात्रा दर्ज करें",
  [LangKeys.enter_sold_quantity]: "बेची गई मात्रा दर्ज करें",
  [LangKeys.quantity]: "मात्रा",
  [LangKeys.add_notes_optional]: "नोट्स जोड़ें (वैकल्पिक)",
  [LangKeys.stock_in_caps]: "स्टॉक इन",
  [LangKeys.stock_out_caps]: "स्टॉक आउट",
  [LangKeys.total_stock]: "कुल स्टॉक",
  [LangKeys.low_stock_items]: "कम स्टॉक वाले आइटम",
  [LangKeys.all_items]: "सभी आइटम",
  [LangKeys.failed_to_load_items]: "आइटम लोड करने में विफल",


  // ================= ITEMS SALES REPORT SCREEN =================

  [LangKeys.item_sales_report]: "आइटम बिक्री रिपोर्ट",
  [LangKeys.total_qty_sold]: "कुल बेची गई मात्रा",
  [LangKeys.units]: "यूनिट",
  [LangKeys.nos]: "नंबर",
  [LangKeys.sold]: "बेचा",
  [LangKeys.bought]: "खरीदा",
  [LangKeys.profit]: "लाभ",
  [LangKeys.loss]: "हानि",

  // Filter & Sort
  [LangKeys.filter_by_stock]: "स्टॉक के अनुसार फ़िल्टर करें",
  [LangKeys.sort_by_name_az]: "नाम (A–Z) के अनुसार",
  [LangKeys.sort_by_name_za]: "नाम (Z–A) के अनुसार",

  // ADD SERVICE SCREEN
  [LangKeys.failed_to_process_image]: "इमेज प्रोसेस नहीं हो सकी",
  [LangKeys.could_not_pick_image]: "इमेज चयन नहीं हो सकी",
  [LangKeys.failed_to_upload_photo]: "फोटो अपलोड नहीं हो सकी",
  [LangKeys.failed_to_update_service]: "सेवा अपडेट नहीं हो सकी",
  [LangKeys.failed_to_add_service]: "सेवा जोड़ने में असफल",
  [LangKeys.are_you_sure_delete_service]: "क्या आप इस सेवा को डिलीट करना चाहते हैं?",
  [LangKeys.failed_to_delete_service]: "सेवा डिलीट नहीं हो सकी",
  [LangKeys.add_sac_and_gst_details]: "SAC और GST की जानकारी जोड़ें",
  [LangKeys.sac_code]: "SAC कोड",
  [LangKeys.enter_sac]: "SAC दर्ज करें",
  [LangKeys.enter_service_name_here]: "यहाँ सेवा का नाम लिखें",
  [LangKeys.please_enter_service_name]: "कृपया सेवा का नाम दर्ज करें",
  [LangKeys.tax_included_in_price]: "कीमत में टैक्स शामिल है",
  [LangKeys.delete_service]: "सेवा डिलीट करें",
  [LangKeys.save_changes]: "बदलाव सेव करें",

  // ITEM DETAILS SCREEN
  [LangKeys.edit_product]: "प्रोडक्ट एडिट करें",
  [LangKeys.stock_quantity]: "स्टॉक मात्रा",
  [LangKeys.stock_value]: "स्टॉक मूल्य",

  // SERVICE DETAILS SCREEN
  [LangKeys.edit_service_caps]: "सेवा एडिट करें",
  [LangKeys.service_name]: "सेवा का नाम",
  [LangKeys.gst_percent]: "GST प्रतिशत",
  [LangKeys.no_sales_added_for_service]: "इस सेवा के लिए कोई बिक्री नहीं जोड़ी गई है",
  [LangKeys.zero_percent]: "शून्य प्रतिशत",

  // BILLS SCREEN
  [LangKeys.bills_add_sale]: "बिक्री जोड़ें",
  [LangKeys.bills_search_sales_hint]: "बिक्री खोजें",
  [LangKeys.bills_add_purchase]: "खरीद जोड़ें",
  [LangKeys.bills_search_purchases_hint]: "खरीद खोजें",
  [LangKeys.bills_add_expense]: "खर्च जोड़ें",
  [LangKeys.bills_search_expenses_hint]: "खर्च खोजें",
  [LangKeys.bills_start_creating_gst]: "GST बिल बनाना शुरू करें",
  [LangKeys.bills_tab_sale]: "बिक्री",
  [LangKeys.bills_tab_purchase]: "खरीद",
  [LangKeys.bills_tab_expense]: "खर्च",
  [LangKeys.bills_monthly_sales]: "मासिक बिक्री",
  [LangKeys.bills_monthly_purchases]: "मासिक खरीद",
  [LangKeys.bills_view_reports]: "रिपोर्ट देखें",
  [LangKeys.bills_todays_in]: "आज की आवक",
  [LangKeys.bills_todays_out]: "आज की जावक",
  [LangKeys.bills_cashbook]: "कैशबुक",
  [LangKeys.bills_added_to_ledger]: "✓ खाते में जोड़ा गया",

  // EXPENSE DETAILS SCREEN
  [LangKeys.expense_number_prefix]: "खर्च #",
  [LangKeys.edit_expense]: "खर्च संपादित करें",
  [LangKeys.delete_expense]: "खर्च हटाएं",
  [LangKeys.deleting_expense]: "हटाया जा रहा...",
  [LangKeys.expense_deleted_successfully]: "खर्च सफलतापूर्वक हटाया गया",
  [LangKeys.failed_to_delete_expense]: "खर्च हटाने में विफल",
  [LangKeys.edit_feature_coming_soon]: "संपादन सुविधा जल्द आ रही है!",
  [LangKeys.delete_expense_confirmation]: "क्या आप वाकई इस खर्च को हटाना चाहते हैं?",
  [LangKeys.bills_empty_state_title]: "तुरंत मनपसंद प्रोफेशनल इनवॉइस बनाएं",
  [LangKeys.bills_empty_state_subtitle]: "लेजर, स्टॉक और कैशबुक अपने आप अपडेट होते हैं",
  [LangKeys.bills_empty_state_gst_support]: "GST और Non-GST दोनों बिलिंग समर्थित",
  [LangKeys.bills_see_sample_invoices]: "नमूना इनवॉइस देखें",
  [LangKeys.bills_no_matching_found]: "कोई मिलान करने वाला बिल नहीं मिला",
  [LangKeys.bills_payment_in]: "पेमेंट प्राप्त",
  [LangKeys.bills_status_fully_paid]: "पूरी तरह भुगतान",
  [LangKeys.bills_status_unpaid]: "बकाया",
  [LangKeys.bills_sale_bill]: "बिक्री बिल",
  [LangKeys.bills_purchase_bill]: "खरीद बिल",
  [LangKeys.bills_expense_bill]: "खर्च",
  [LangKeys.bills_more_button]: "और",

  // FILTER & SORT
  [LangKeys.filter_and_sort]: "फ़िल्टर और सॉर्ट",
  [LangKeys.filter_by_status]: "स्थिति के अनुसार फ़िल्टर",
  [LangKeys.filter_all_bills]: "सभी बिल",
  [LangKeys.filter_paid_bills]: "भुगतान किए गए बिल",
  [LangKeys.filter_unpaid_bills]: "बिना भुगतान वाले बिल",
  [LangKeys.sort_by]: "क्रमबद्ध करें",
  [LangKeys.sort_latest_first]: "नवीनतम पहले",
  [LangKeys.sort_oldest_first]: "सबसे पुराने पहले",
  [LangKeys.sort_highest_amount]: "सबसे अधिक राशि",
  [LangKeys.sort_lowest_amount]: "सबसे कम राशि",
  [LangKeys.clear_filters]: "फ़िल्टर हटाएं",
  [LangKeys.apply_filters]: "फ़िल्टर लागू करें",

  // ADD BILL SCREEN
  [LangKeys.add_bill_sale]: "बिक्री",
  [LangKeys.add_bill_purchase]: "खरीद",
  [LangKeys.add_bill_expense]: "खर्च",
  [LangKeys.add_bill_edit_sale_gst_bill]: "बिक्री GST बिल संपादित करें",
  [LangKeys.add_bill_sale_gst_bill]: "बिक्री GST बिल",
  [LangKeys.add_bill_edit_purchase_gst_bill]: "खरीद GST बिल संपादित करें",
  [LangKeys.add_bill_purchase_gst_bill]: "खरीद GST बिल",
  [LangKeys.add_bill_edit_expense]: "खर्च संपादित करें",
  [LangKeys.add_bill_expense_title]: "खर्च",
  [LangKeys.add_bill_edit_sale_bill]: "बिक्री बिल संपादित करें",
  [LangKeys.add_bill_sale_bill]: "बिक्री बिल",
  [LangKeys.add_bill_edit_purchase_bill]: "खरीद बिल संपादित करें",
  [LangKeys.add_bill_purchase_bill]: "खरीद बिल",
  [LangKeys.add_bill_sale_bill_no]: "बिक्री बिल नं.",
  [LangKeys.add_bill_purchase_bill_no]: "खरीद बिल नं.",
  [LangKeys.add_bill_expense_no]: "खर्च नं.",
  [LangKeys.add_bill_update_sale_bill]: "बिक्री बिल अपडेट करें",
  [LangKeys.add_bill_generate_sale_bill]: "बिक्री बिल बनाएं",
  [LangKeys.add_bill_update_purchase_bill]: "खरीद बिल अपडेट करें",
  [LangKeys.add_bill_generate_purchase_bill]: "खरीद बिल बनाएं",
  [LangKeys.add_bill_update_expense]: "खर्च अपडेट करें",
  [LangKeys.add_bill_generate_expense]: "खर्च जोड़ें",
  [LangKeys.add_bill_select_customer_error]: "कृपया ग्राहक चुनें",
  [LangKeys.add_bill_add_item_error]: "कम से कम एक आइटम जोड़ें",
  [LangKeys.add_bill_updated_successfully]: "सफलतापूर्वक अपडेट किया गया",
  [LangKeys.add_bill_saved_successfully]: "सफलतापूर्वक सहेजा गया",
  [LangKeys.add_bill_failed_to_save]: "बिल सहेजने में विफल",
  [LangKeys.add_bill_error_occurred]: "कुछ गलत हो गया",
  [LangKeys.add_bill_bill_to]: "बिल किसके नाम",
  [LangKeys.add_bill_search_parties]: "पार्टी खोजें",
  [LangKeys.add_bill_add_new_party]: "नई पार्टी जोड़ें",
  [LangKeys.add_bill_edit_party_details]: "पार्टी विवरण संपादित करें",
  [LangKeys.add_bill_items]: "आइटम",
  [LangKeys.add_bill_enter_items_from_inventory]: "स्टॉक से आइटम जोड़ें",
  [LangKeys.add_bill_add_new_item]: "नया आइटम जोड़ें",
  [LangKeys.add_bill_n_items]: "{n} आइटम",
  [LangKeys.add_bill_edit_or_add_items]: "आइटम जोड़ें या संपादित करें",
  [LangKeys.add_bill_discount]: "छूट",
  [LangKeys.add_bill_extra_discount]: "अतिरिक्त छूट",
  [LangKeys.add_bill_item_subtotal]: "आइटम उप-योग",
  [LangKeys.add_bill_round_off]: "राउंड ऑफ",
  [LangKeys.add_bill_bill_amount]: "बिल राशि",
  [LangKeys.add_bill_optional_fields]: "वैकल्पिक विवरण",
  [LangKeys.add_bill_printed_on_invoice]: "इनवॉइस पर मुद्रित",
  [LangKeys.add_bill_custom_fields]: "कस्टम फ़ील्ड",
  [LangKeys.add_bill_party_address]: "पार्टी का पता",
  [LangKeys.add_bill_your_address]: "आपका पता",
  [LangKeys.add_bill_terms_conditions]: "नियम व शर्तें",
  [LangKeys.add_bill_private_to_you]: "केवल आपके लिए",
  [LangKeys.add_bill_add_notes_photos]: "नोट्स या फोटो जोड़ें",
  [LangKeys.add_bill_n_photos_added]: "{n} फोटो जोड़े गए",
  [LangKeys.add_bill_balance_due]: "बकाया राशि",
  [LangKeys.cgst]: "सीजीएसटी",
  [LangKeys.sgst]: "एसजीएसटी",
  [LangKeys.pending_bill_no]: "बकाया बिल नं.",
  [LangKeys.add_bill_add_due_to_ledger]: "बकाया राशि खाते में जोड़े",
  [LangKeys.add_bill_select_supplier_error]: "कृपया सप्लायर चुनें",

  // BILL DETAILS SCREEN
  [LangKeys.bill_details_error_id_missing]: "बिल आईडी उपलब्ध नहीं है",
  [LangKeys.bill_details_failed_to_load]: "बिल लोड करने में विफल",
  [LangKeys.bill_details_delete_confirmation_title]: "बिल हटाएं",
  [LangKeys.bill_details_delete_confirmation_content]: "क्या आप वाकई इस बिल को हटाना चाहते हैं? याद रखें बिल से जुड़ी कैशबुक एंट्री भी हटा दी जाएगी",
  [LangKeys.bill_details_delete_button]: "हटाएं",
  [LangKeys.bill_details_deleted_successfully]: "बिल सफलतापूर्वक हटाया गया",
  [LangKeys.bill_details_failed_to_delete]: "बिल हटाने में विफल",
  [LangKeys.bill_details_generating_pdf]: "PDF बनाई जा रही है",
  [LangKeys.bill_details_share_text]: "यह रहा आपका बिल",
  [LangKeys.bill_details_failed_to_share]: "बिल साझा करने में विफल",
  [LangKeys.bill_details_title]: "बिल विवरण",
  [LangKeys.bill_details_could_not_load]: "बिल विवरण लोड नहीं हो सका",
  [LangKeys.bill_details_status]: "स्थिति",
  [LangKeys.bill_details_status_pending]: "लंबित",
  [LangKeys.bill_details_no_items]: "कोई आइटम जोड़ा नहीं गया",
  [LangKeys.bill_details_view_pdf]: "PDF देखें",

  // INVOICE PREVIEW SCREEN
  [LangKeys.invoice_preview_title]: "इनवॉइस प्रीव्यू",
  [LangKeys.invoice_preview_generating]: "इनवॉइस बनाई जा रही है",
  [LangKeys.invoice_preview_failed]: "इनवॉइस बनाने में विफल",
  [LangKeys.invoice_preview_preparing_print]: "प्रिंट के लिए तैयार किया जा रहा है",
  [LangKeys.invoice_preview_failed_print]: "प्रिंट करने में विफल",
  [LangKeys.invoice_preview_delete_title]: "इनवॉइस हटाएं",
  [LangKeys.invoice_preview_delete_content]: "क्या आप इस इनवॉइस को हटाना चाहते हैं? याद रखें इस इनवॉइस से जुड़ी कैशबुक एंट्री भी हटा दी जाएगी।",
  [LangKeys.invoice_preview_deleted_successfully]: "इनवॉइस सफलतापूर्वक हटाई गई",
  [LangKeys.invoice_preview_failed_delete]: "इनवॉइस हटाने में विफल",
  [LangKeys.invoice_preview_theme_premium]: "प्रीमियम",
  [LangKeys.invoice_preview_theme_thermal]: "थर्मल",
  [LangKeys.invoice_preview_theme_basic]: "बेसिक",
  [LangKeys.invoice_preview_theme_new]: "नया",
  [LangKeys.invoice_preview_download]: "इनवॉइस डाउनलोड करें",
  [LangKeys.invoice_preview_share]: "इनवॉइस साझा करें",
  [LangKeys.invoice_preview_print]: "इनवॉइस प्रिंट करें",
  [LangKeys.invoice_preview_create_new]: "नया बनाएं",
  [LangKeys.invoice_preview_done]: "पूर्ण",

  // PAYMENT DETAILS SCREEN
  [LangKeys.payment_details_title_in]: "पेमेंट प्राप्त",
  [LangKeys.payment_details_title_out]: "पेमेंट दिया",
  [LangKeys.payment_details_share_text]: "पेमेंट विवरण",
  [LangKeys.payment_details_failed_to_share]: "पेमेंट विवरण साझा करने में विफल",
  [LangKeys.payment_details_adjusted_invoices]: "समायोजित इनवॉइस",

  // SAMPLE INVOICES SCREEN
  [LangKeys.sample_invoice_title]: "नमूना",
  [LangKeys.premium_invoice]: "प्रीमियम इनवॉइस",
  [LangKeys.thermal_invoice]: "थर्मल इनवॉइस",
  [LangKeys.basic_invoice]: "बेसिक इनवॉइस",
  [LangKeys.use_this_template]: "इस टेम्पलेट का उपयोग करें",

  // ITEM SELECT SHEET
  [LangKeys.item_select_not_enough_stock]: "पर्याप्त स्टॉक उपलब्ध नहीं है। केवल {availableStock} उपलब्ध है।",
  [LangKeys.item_select_no_items_found]: "कोई आइटम नहीं मिला",
  [LangKeys.item_select_item_discount]: "आइटम छूट",
  [LangKeys.item_select_final_price]: "अंतिम कीमत",
  [LangKeys.item_select_gst_rate]: "GST दर",
  [LangKeys.item_select_item_single]: "आइटम",
  [LangKeys.item_select_item_plural]: "आइटम",
  [LangKeys.item_select_continue]: "जारी रखें",
  [LangKeys.item_select_add_items_to_invoice]: "इनवॉइस में आइटम जोड़ें",
  [LangKeys.item_select_search_created_items]: "बनाए गए आइटम खोजें",
  [LangKeys.item_select_add_new]: "नया जोड़ें",

  // QUICK ADD ITEM DIALOG
  [LangKeys.add_more_details]: "और विवरण जोड़ें (स्टॉक, खरीद मूल्य आदि)",
  [LangKeys.add_item_to_bill]: "बिल में आइटम जोड़ें",
  [LangKeys.please_enter_value]: "कृपया मान दर्ज करें",
  [LangKeys.please_enter_valid_number]: "कृपया सही संख्या दर्ज करें",

  // CUSTOM FIELDS DIALOG
  [LangKeys.add_bill_custom_fields_subtitle]: "अधिकतम 5 कस्टम फ़ील्ड जोड़ें (जैसे- सीरियल नंबर, बैच, IMEI आदि)",
  [LangKeys.add_bill_add_new_custom_field]: "नया कस्टम फ़ील्ड जोड़ें",
  [LangKeys.add_bill_max_custom_fields]: "आप अधिकतम 5 कस्टम फ़ील्ड जोड़ सकते हैं।",
  [LangKeys.add_bill_custom_field_name_hint]: "फ़ील्ड नाम",
  [LangKeys.add_bill_custom_field_value_hint]: "मान",

  // EDIT PRICE DIALOG
  [LangKeys.edit_price_gst_details]: "({cgst}% CGST + {sgst}% SGST; {igst}% IGST)",
  [LangKeys.edit_price_enter_discount_hint]: "छूट दर्ज करें",
  [LangKeys.rupee]: "रुपया",
  [LangKeys.percentage]: "प्रतिशत",
  [LangKeys.rate]: "दर",
  [LangKeys.tax]: "कर",

  // ADDRESS SCREEN
  [LangKeys.address_business_address_title]: "व्यवसाय का पता",
  [LangKeys.address_flat_building_number]: "फ्लैट / बिल्डिंग नंबर",
  [LangKeys.address_enter_flat_building_number]: "कृपया फ्लैट/बिल्डिंग नंबर दर्ज करें",
  [LangKeys.address_area_locality]: "क्षेत्र / मोहल्ला",
  [LangKeys.address_enter_area_locality]: "कृपया क्षेत्र/मोहल्ला दर्ज करें",
  [LangKeys.address_city]: "शहर",
  [LangKeys.address_enter_city]: "कृपया शहर दर्ज करें",
  [LangKeys.address_state]: "राज्य",
  [LangKeys.address_enter_state]: "कृपया राज्य दर्ज करें",
  [LangKeys.address_pincode]: "पिनकोड",
  [LangKeys.address_enter_pincode]: "कृपया पिनकोड दर्ज करें",
  [LangKeys.address_invalid_pincode]: "अमान्य पिनकोड",

  // PARTY ADDRESS SCREEN
  [LangKeys.party_address_title]: "ग्राहक का पता",
  [LangKeys.party_address_billing_address]: "बिलिंग पता",
  [LangKeys.party_address_shipping_same_as_billing]: "शिपिंग पता बिलिंग के समान",

  // ADD NOTES AND PHOTOS DIALOG
  [LangKeys.add_notes_and_photos_title]: "नोट्स और फोटो जोड़ें",
  [LangKeys.add_notes_and_photos_subtitle]: "अतिरिक्त विवरण या तस्वीरें जोड़ें",
  [LangKeys.add_notes_and_photos_notes_hint]: "यहाँ नोट्स लिखें",
  [LangKeys.photos_access_permanently_denied]: "फोटो एक्सेस स्थायी रूप से अस्वीकृत है। कृपया ऐप सेटिंग्स में जाकर अनुमति दें।",
  [LangKeys.photos_access_denied]: "फोटो चुनने के लिए कृपया डिवाइस सेटिंग्स में जाकर कैमरा या फोटो एक्सेस की अनुमति दें।",
  [LangKeys.open_settings]: "सेटिंग्स खोलें",

  // TERMS AND CONDITIONS DIALOG
  [LangKeys.terms_and_conditions_title]: "नियम व शर्तें",
  [LangKeys.terms_and_conditions_hint]: "नियम व शर्तें दर्ज करें",

  // KHATA TABS
  [LangKeys.customers]: "ग्राहक",
  [LangKeys.suppliers]: "सप्लायर",
  [LangKeys.search_supplier]: "सप्लायर खोजें",
  [LangKeys.add_first_customer]: "अपना पहला ग्राहक जोड़ें",
  [LangKeys.add_first_supplier]: "अपना पहला सप्लायर जोड़ें",
  [LangKeys.add_new_customer_prompt]: "अभी तक कोई ग्राहक जोड़ा नहीं गया है। नया ग्राहक जोड़ने के लिए ऊपर दिए गए “+” बटन पर टैप करें।",
  [LangKeys.add_new_suppliers_prompt]: "अभी तक कोई सप्लायर जोड़ा नहीं गया है। नया सप्लायर जोड़ने के लिए ऊपर दिए गए “+” बटन पर टैप करें।",

  // CASHBOOK HELP DIALOG
  [LangKeys.cashbook_help_title]: "कैशबुक सहायता",
  [LangKeys.cashbook_help_in_title]: "कैश इन (जमा)",
  [LangKeys.cashbook_help_in_desc]: "यहां आपके व्यवसाय में प्राप्त हुई सभी नकद राशियों का रिकॉर्ड दिखाया जाता है।",
  [LangKeys.cashbook_help_out_title]: "कैश आउट (निकासी)",
  [LangKeys.cashbook_help_out_desc]: "यहां आपके व्यवसाय से खर्च की गई सभी नकद राशियों का रिकॉर्ड दिखाया जाता है।",
  [LangKeys.cashbook_help_total_balance_title]: "कुल बैलेंस",
  [LangKeys.cashbook_help_total_balance_desc]: "यह आपके कैशबुक का वर्तमान कुल बैलेंस दर्शाता है।",
  [LangKeys.cashbook_help_today_balance_title]: "आज का बैलेंस",
  [LangKeys.cashbook_help_today_balance_desc]: "यह केवल आज की नकद लेनदेन के आधार पर बैलेंस दिखाता है।",
  [LangKeys.cashbook_help_report_title]: "कैशबुक रिपोर्ट",
  [LangKeys.cashbook_help_report_desc]: "आप यहां से कैशबुक की रिपोर्ट देख और डाउनलोड कर सकते हैं।",

  // ADD EXPENSE SCREEN
  [LangKeys.expense_amount]: "खर्च की राशि",
  [LangKeys.select_category]: "श्रेणी चुनें",
  [LangKeys.select_expense_category]: "खर्च की श्रेणी चुनें",
  [LangKeys.expense_items_warning]: "खर्च की वस्तुएं आपके इन्वेंट्री आइटम्स को प्रभावित नहीं करेंगी।",
  [LangKeys.add_expense_items_optional]: "खर्च की वस्तुएं जोड़ें (वैकल्पिक)",
  [LangKeys.expense_items_feature_coming_soon]: "खर्च वस्तु सुविधा जल्द आ रही है!",
  [LangKeys.notes_and_photos_optional]: "नोट्स और फोटो (वैकल्पिक)",
  [LangKeys.photos_added]: "फोटो जोड़ी गईं",
  [LangKeys.save_expense_amount]: "खर्च सेव करें",
  [LangKeys.update_expense_amount]: "खर्च अपडेट करें",
  [LangKeys.expense_saved_successfully]: "खर्च सफलतापूर्वक सेव हो गया",
  [LangKeys.expense_updated_successfully]: "खर्च सफलतापूर्वक अपडेट हो गया",
  [LangKeys.failed_to_save_expense]: "खर्च सेव करने में असफल",
  [LangKeys.enter_valid_amount]: "कृपया सही राशि दर्ज करें।",
  [LangKeys.please_select_expense_category]: "कृपया खर्च की श्रेणी चुनें।",
  [LangKeys.category]: "श्रेणी",

  // EXPENSE CATEGORIES
  [LangKeys.cat_rent]: "किराया",
  [LangKeys.cat_salaries]: "वेतन / मजदूरी",
  [LangKeys.cat_electricity]: "बिजली",
  [LangKeys.cat_water]: "पानी का बिल",
  [LangKeys.cat_internet]: "टेलीफोन / इंटरनेट",
  [LangKeys.cat_office]: "ऑफिस खर्च",
  [LangKeys.cat_marketing]: "मार्केटिंग / विज्ञापन",
  [LangKeys.cat_travel]: "यात्रा",
  [LangKeys.cat_fuel]: "ईंधन / पेट्रोल",
  [LangKeys.cat_food]: "खाना / जलपान",
  [LangKeys.cat_repairs]: "मरम्मत और रखरखाव",
  [LangKeys.cat_election]: "चुनाव खर्च",
  [LangKeys.cat_taxes]: "कर / जीएसटी",
  [LangKeys.cat_insurance]: "बीमा",
  [LangKeys.cat_cleaning]: "सफाई",
  [LangKeys.cat_delivery]: "डिलीवरी / शिपिंग",
  [LangKeys.cat_software]: "सॉफ्टवेयर / ऐप्स",
  [LangKeys.cat_furniture]: "फर्नीचर",
  [LangKeys.cat_other]: "अन्य",

  // EXPENSE EMPTY STATE
  [LangKeys.expense_empty_title]: "अपने खर्चों को आसानी से प्रबंधित करें",
  [LangKeys.expense_empty_subtitle]: "अपने सभी व्यावसायिक खर्चों को एक ही स्थान पर ट्रैक करें।",
  [LangKeys.expense_empty_footer]: "कैशबुक में सभी खर्च स्वचालित रूप से जुड़ जाते हैं।",

  // BILL REPORT SCREEN
  [LangKeys.bill_report_title]: "बिल रिपोर्ट",
  [LangKeys.report_for_period]: "इस अवधि की रिपोर्ट",
  [LangKeys.select_date_range]: "तारीख सीमा चुनें",
  [LangKeys.total_sales]: "कुल बिक्री",
  [LangKeys.total_purchases]: "कुल खरीद",
  [LangKeys.total_expenses]: "कुल खर्च",
  [LangKeys.net_profit]: "शुद्ध लाभ",
  [LangKeys.net_loss]: "शुद्ध हानि",
  [LangKeys.all_transactions]: "सभी लेनदेन",
  [LangKeys.no_transactions_found_period]: "इस अवधि में कोई लेनदेन नहीं मिला",
  [LangKeys.expense_fallback_category]: "अन्य खर्च",

  // SALES REPORT SCREEN
  [LangKeys.sales_report]: "बिक्री रिपोर्ट",
  [LangKeys.transactions]: "लेनदेन",
  [LangKeys.net_sale]: "शुद्ध बिक्री",
  [LangKeys.unpaid_balance]: "बकाया राशि",
  [LangKeys.sales_report_share_text]: "यह आपकी बिक्री रिपोर्ट का सारांश है।",

  // PURCHASE REPORT SCREEN
  [LangKeys.purchase_report]: "खरीद रिपोर्ट",
  [LangKeys.net_purchase]: "शुद्ध खरीद",
  [LangKeys.purchase_report_share_text]: "यह आपकी खरीद रिपोर्ट का सारांश है।",

  // KHATA FILTER & SORT
  [LangKeys.filter_by_balance]: "बैलेंस के अनुसार फ़िल्टर",
  [LangKeys.filter_all_parties]: "सभी पार्टियाँ",

  // LOGOUT
  [LangKeys.logout_confirm]: "क्या आप वाकई लॉगआउट करना चाहते हैं?",
  [LangKeys.confirm_logout]: "लॉगआउट",

  // DEVICES
  [LangKeys.manage_devices]: "डिवाइस मैनेज करें",
  [LangKeys.active_devices]: "सक्रिय डिवाइस",
  [LangKeys.logout_device]: "डिवाइस लॉगआउट",
  [LangKeys.logout_device_confirm]: "क्या आप इस डिवाइस को लॉगआउट करना चाहते हैं?",
  [LangKeys.device_logged_out]: "डिवाइस सफलतापूर्वक लॉगआउट हो गया",
  [LangKeys.no_active_devices]: "कोई सक्रिय डिवाइस नहीं है",
  [LangKeys.last_login]: "अंतिम लॉगिन",
  [LangKeys.this_device]: "यह डिवाइस",
  [LangKeys.loading_devices]: "डिवाइस लोड हो रहे हैं...",

  // SMS SETTINGS
  [LangKeys.send_whatsapp_messages]: "व्हाट्सएप मैसेज भेजना",
  [LangKeys.enabled]: "चालू",
  [LangKeys.disabled]: "बंद",
  [LangKeys.manage_whatsapp_settings]: "व्हाट्सएप SMS सेटिंग्स मैनेज करें",
  [LangKeys.recharge_and_control]: "क्रेडिट रिचार्ज करें और मैसेज कंट्रोल करें",
  [LangKeys.wa_message_sent]: "मैसेज भेज दिया गया",
  [LangKeys.wa_message_pending]: "मैसेज लंबित है",
  [LangKeys.wa_message_disabled]: "मैसेज बंद है",
  [LangKeys.wa_message_failed]: "मैसेज भेजा नहीं जा सका",
  [LangKeys.wa_no_credits]: "क्रेडिट खत्म, मैसेज नहीं गया",

  // DASHBOARD EMPTY STATE
  [LangKeys.pro_tip]: "प्रो टिप",
  [LangKeys.dashboard_empty_tip]: "पूरा विवरण देखने, संपादित करने या ग्राहकों के साथ साझा करने के लिए बाईं ओर किसी भी प्रविष्टि पर क्लिक करें।",
  [LangKeys.select_entry]: "प्रविष्टि चुनें",
  [LangKeys.entry_details_appear]: "प्रविष्टि का विवरण यहाँ दिखाई देगा",

  // PREMIUM
  [LangKeys.plan_standard_name]: "स्टैंडर्ड (विज्ञापन फ्री)",
  [LangKeys.plan_ads_free_name]: "Ads Free +",
  [LangKeys.plan_premium_name]: "Premium",
  [LangKeys.plan_recommended_tag]: "सुझाया गया प्लान",
  [LangKeys.plan_duration_30_days]: "30 दिनों के लिए",
  [LangKeys.plan_duration_180_days]: "180 दिनों (6 महीने) के लिए",
  [LangKeys.plan_duration_365_days]: "365 दिनों (1 साल) के लिए",
  [LangKeys.plan_duration_30_days_badge]: "30 दिन",
  [LangKeys.plan_save_20_percent]: "बचत ~20%",
  [LangKeys.plan_best_value_badge]: "बेस्ट वैल्यू",
  [LangKeys.plan_best_value_plan_tag]: "बेस्ट वैल्यू प्लान",
  [LangKeys.plan_most_popular_save]: "सबसे लोकप्रिय • ₹{amount} की बचत",
  [LangKeys.plan_save_amount_tag]: "₹{amount} की बचत",
  [LangKeys.duration_1_month]: "1 महीना",
  [LangKeys.duration_6_months]: "6 महीने",
  [LangKeys.duration_12_months]: "12 महीने",
  [LangKeys.plan_save_text]: "बचत करें",
  [LangKeys.benefit_no_ads]: "विज्ञापन मुक्त अनुभव (100% Ads Free)",
  [LangKeys.benefit_support]: "24/7 प्राथमिकता ग्राहक सहायता",
  [LangKeys.benefit_all_ads_free]: "Ads Free + प्लान के सभी लाभ",
  [LangKeys.benefit_multiple_devices]: "एक साथ कई डिवाइस लॉगिन",
  [LangKeys.benefit_desktop_access]: "कंप्यूटर/डेस्कटॉप पर भी उपयोग करें",
  [LangKeys.benefit_create_bills]: "बिल बनाएं (सामान्य बिल, GST बिल)",
  [LangKeys.benefit_defaulters_list]: "एक क्लिक में डिफॉल्टर्स सूची देखें",
  [LangKeys.benefit_organize_lists]: "सूचियों के साथ अपने खाते व्यवस्थित करें",
  [LangKeys.benefit_manage_stocks]: "स्टॉक प्रबंधित करें (लेनदेन के साथ आइटम जोड़ें)",
  [LangKeys.benefit_financial_reports]: "प्रीमियम वित्तीय रिपोर्ट (PDF/Excel)",
  [LangKeys.benefit_dual_backup]: "सुरक्षित स्थानीय और क्लाउड बैकअप",
  [LangKeys.benefit_unlimited_entry]: "कैशबुक/खाता में असीमित प्रविष्टियां (अनलिमिटेड एंट्री)",
  [LangKeys.benefit_unlimited_transactions]: "असीमित लेनदेन (Unlimited Transactions)",
  [LangKeys.benefit_unlimited_sms]: "असीमित ट्रांजेक्शन SMS",
  [LangKeys.benefit_dairy_management]: "डेयरी फीचर्स (दूध रिकॉर्ड, रेट चार्ट, बिल)",
  [LangKeys.benefit_refer_earn]: "रेफर करें और कमाएं (फ्री रिचार्ज वैधता)",
  [LangKeys.my_subscription_title]: "मेरी सदस्यता",
  [LangKeys.premium_plans_title]: "हमारे प्रीमियम प्लान्स",
  [LangKeys.active_badge_label]: "सक्रिय",
  [LangKeys.expires_on_label]: "समाप्त {date}",
  [LangKeys.expired_badge_label]: "समाप्त",
  [LangKeys.expired_on_label]: "{date} को समाप्त हो गया",
  [LangKeys.extend_plan_label]: "प्लान बढ़ाएं (+{days} दिन)",
  [LangKeys.days_remaining_label]: "({days} दिन शेष)",
  [LangKeys.secure_checkout_label]: "100% सुरक्षित SSL भुगतान",
  [LangKeys.upgrade_button]: "अपग्रेड",
  [LangKeys.downgrade_button]: "डाउनग्रेड करें",

  // REPORTS DASHBOARD
  [LangKeys.business_reports]: "व्यावसायिक रिपोर्ट",
  [LangKeys.business_reports_desc]: "आपके व्यवसाय के लिए विश्लेषण और जानकारी",
  [LangKeys.ledger_cashbook_reports]: "बहीखाता और कैशबुक रिपोर्ट",
  [LangKeys.billing_inventory_reports]: "बिलिंग और इन्वेंटरी रिपोर्ट",
  [LangKeys.customer_ledger_statement_report]: "ग्राहक खाता रिपोर्ट",
  [LangKeys.customer_ledger_report_desc]: "सभी ग्राहकों के लिए विस्तृत बहीखाता और लेनदेन इतिहास",
  [LangKeys.supplier_ledger_statement_report]: "सप्लायर खाता रिपोर्ट",
  [LangKeys.supplier_ledger_report_desc]: "सभी सप्लायरों के लिए विस्तृत बहीखाता और लेनदेन इतिहास",
  [LangKeys.cashbook_report_desc]: "नकद और ऑनलाइन लेनदेन का दैनिक विवरण",
  [LangKeys.sales_report_desc]: "बिल-वार बिक्री सारांश, कुल बिक्री और बकाया राशि",
  [LangKeys.purchase_report_desc]: "बिल-वार खरीद रिकॉर्ड और खरीद सारांश",
  [LangKeys.bills_summary_report]: "बिल सारांश रिपोर्ट",
  [LangKeys.bills_summary_report_desc]: "बिक्री, खरीद और लाभ-हानि का संपूर्ण विश्लेषण",
  [LangKeys.item_stock_sales_report]: "आइटम स्टॉक और बिक्री रिपोर्ट",
  [LangKeys.item_stock_sales_report_desc]: "उत्पादों और सेवाओं के स्टॉक और बिक्री का विवरण",
  [LangKeys.select_party]: "पार्टी चुनें",
  [LangKeys.search_placeholder]: "नाम या मोबाइल से खोजें...",
  [LangKeys.back_to_dashboard]: "रिपोर्ट मेनू पर वापस जाएं",
  [LangKeys.loading_report_data]: "रिपोर्ट डेटा लोड हो रहा है...",
  [LangKeys.no_parties_found]: "कोई पार्टी नहीं मिली।",
  [LangKeys.select_customer]: "रिपोर्ट देखने के लिए ग्राहक चुनें",
  [LangKeys.select_supplier]: "रिपोर्ट देखने के लिए सप्लायर चुनें",
  [LangKeys.premium_feature]: "प्रीमियम फीचर",
  [LangKeys.premium_lock_desc]: "प्रोफेशनल बिलिंग, सेल/परचेज इनवॉइस रिपोर्ट, डेबुक स्टेटमेंट और इन्वेंटरी सारांश अनलॉक करें।",
  [LangKeys.upgrade_to_premium]: "विज्ञापन मुक्त+ / प्रीमियम में अपग्रेड करें 🚀",

  // Business Profile & Marketplace
  [LangKeys.biz_profile__marketplace_settings]: 'ऑनलाइन स्टोर सेटिंग्स (Moxpal Market)',
  [LangKeys.biz_profile__online_business_toggle]: 'ऑनलाइन बिज़नेस चालू रखें',
  [LangKeys.biz_profile__online_business_active]: 'बिज़नेस ऑनलाइन चालू है (Active)',
  [LangKeys.biz_profile__online_business_offline]: 'बिज़नेस ऑनलाइन बंद है (Offline)',
  [LangKeys.biz_profile__gps_pending_badge]: 'ऑनलाइन चालू है (GPS सेट करें)',
  [LangKeys.biz_profile__online_business_sub_active]: 'चालू करने के बाद 1-क्लिक में राज्य, ज़िला, इलाका व पिनकोड भरें और GPS लोकेशन सेट करें, ताकि आपके प्रोडक्ट और सेवाएं आसपास के ग्राहकों को तुरंत ऑनलाइन दिख सकें।',
  [LangKeys.biz_profile__online_business_sub_offline]: 'बिज़नेस को ऑनलाइन चालू करें ताकि आसपास के ग्राहक आपके प्रोडक्ट और सेवाएं लोकल मार्केट में खोज सकें।',
  [LangKeys.biz_profile__know_benefits_btn]: '💡 इसके फायदे व नियम जानें',
  [LangKeys.biz_profile__benefits_modal_title]: 'ऑनलाइन बिज़नेस के फायदे व पूरी जानकारी',
  [LangKeys.biz_profile__benefits_step1_title]: '1. इसे चालू करने से क्या होगा?',
  [LangKeys.biz_profile__benefits_step1_desc]: 'आपका बिज़नेस, प्रोडक्ट और सेवाएं तुरंत लोकल मार्केट में लाइव हो जाएंगी। आसपास के सभी ग्राहक आपके प्रोडक्ट और सेवाएं देख सकेंगे और सीधे आपसे जुड़ सकेंगे।',
  [LangKeys.biz_profile__benefits_step2_title]: '2. आपको क्या-क्या करना है?',
  [LangKeys.biz_profile__benefits_step2_desc]: '• नीले बटन (⚡ 1-क्लिक) से राज्य, ज़िला, इलाका, पिनकोड और GPS सेट करें।\n• अपने प्रोडक्ट या सेवाएं जोड़ें ताकि ग्राहक उन्हें देख सकें।',
  [LangKeys.biz_profile__benefits_step3_title]: '3. इसके क्या-क्या फायदे मिलेंगे?',
  [LangKeys.biz_profile__benefits_step3_desc]: '• 0% कमीशन (100% फ्री) — कोई बिचौलिया नहीं।\n• सीधे WhatsApp और कॉल पर ग्राहकों से ऑर्डर व बुकिंग पाएं।\n• 24 घंटे खुला डिजिटल बिज़नेस — कभी भी ग्राहक प्रोडक्ट और सेवाएं देख सकते हैं।\n• पूरे इलाके में आपके बिज़नेस की पहचान और नई बिक्री बढ़ेगी।',
  [LangKeys.biz_profile__benefits_btn_got_it]: 'समझ गया, ठीक है 👍',
  [LangKeys.biz_profile__autofill_btn_title]: '⚡ 1-क्लिक में पूरा पता ऑटो भरें',
  [LangKeys.biz_profile__autofill_btn_sub]: 'GPS से राज्य, ज़िला, गाँव व पिनकोड अपने-आप भरें',
  [LangKeys.biz_profile__autofill_searching]: 'लोकेशन खोजी जा रही है...',
  [LangKeys.biz_profile__state_lbl]: 'राज्य (State)',
  [LangKeys.biz_profile__state_add]: 'राज्य जोड़ें',
  [LangKeys.biz_profile__state_placeholder]: 'उदा. Rajasthan, Uttar Pradesh, Gujarat...',
  [LangKeys.biz_profile__city_lbl]: 'शहर / ज़िला (City / District)',
  [LangKeys.biz_profile__city_add]: 'शहर जोड़ें',
  [LangKeys.biz_profile__city_placeholder]: 'उदा. बीकानेर, जयपुर, लखनऊ...',
  [LangKeys.biz_profile__area_lbl]: 'गाँव / कस्बा / इलाका (Area / Village)',
  [LangKeys.biz_profile__area_add]: 'गाँव/इलाका जोड़ें',
  [LangKeys.biz_profile__area_placeholder]: 'उदा. साधुसर, नोखा, सदर बाज़ार, कोट गेट...',
  [LangKeys.biz_profile__pincode_lbl]: 'पिनकोड (Pincode)',
  [LangKeys.biz_profile__pincode_add]: 'पिनकोड जोड़ें',
  [LangKeys.biz_profile__pincode_placeholder]: '6 अंकों का पिनकोड दर्ज करें',
  [LangKeys.biz_profile__tagline_lbl]: 'बिज़नेस की टैगलाइन/विवरण',
  [LangKeys.biz_profile__tagline_add]: 'टैगलाइन जोड़ें',
  [LangKeys.biz_profile__tagline_placeholder]: 'उदा. हमारे यहाँ शुद्ध ताज़ा सामान व बेहतरीन सर्विस मिलती है',
  [LangKeys.biz_profile__gps_lbl]: 'बिज़नेस की GPS लोकेशन',
  [LangKeys.biz_profile__gps_not_set]: 'लोकेशन अभी सेट नहीं है',
  [LangKeys.biz_profile__gps_update_btn]: 'अपडेट करें',
  [LangKeys.biz_profile__gps_get_btn]: 'GPS लोकेशन लें',
  [LangKeys.biz_profile__gps_searching]: 'खोज रहे हैं...',
  [LangKeys.biz_profile__gps_live_warning]: '⚠️ स्टोर ऑनलाइन है पर GPS सेट नहीं है! कृपया ⚡ 1-क्लिक बटन से GPS सेट करें ताकि दुकान ग्राहकों को दिख सके।',
  [LangKeys.biz_profile__gps_turn_on_toast]: 'कृपया ब्राउज़र/फोन का GPS Location चालू करें',
  [LangKeys.biz_profile__gps_permission_denied_toast]: 'लोकेशन की अनुमति (Permission) नहीं दी गई',
  [LangKeys.biz_profile__gps_permission_settings_toast]: 'कृपया सेटिंग्स में जाकर Location Permission चालू करें',
  [LangKeys.biz_profile__gps_autofill_success_toast]: 'GPS से पूरा पता (राज्य, ज़िला, गाँव, पिनकोड) अपने-आप भर गया!',
  [LangKeys.biz_profile__gps_error_toast]: 'लोकेशन लेने में त्रुटि',
  [LangKeys.biz_market_video_guide_title]: 'लोकल बाज़ार में दुकान ऑनलाइन कैसे करें?',
  [LangKeys.biz_market_video_guide_sub]: '1 मिनट का वीडियो देखें और सीखें • YouTube Guide',
  [LangKeys.item_video_guide_btn_sub]: "स्टोर व प्रोडक्ट ऑनलाइन एक्टिव करने की गाइड",
  [LangKeys.service_video_guide_btn_sub]: "काम व दुकान ऑनलाइन एक्टिव करने की गाइड",
  [LangKeys.item_marketplace_title]: "ऑनलाइन बाज़ार (Marketplace)",
  [LangKeys.item_marketplace_sub_active]: "यह प्रोडक्ट आसपास के ग्राहकों को ऑनलाइन दिखेगा, वे आपसे सीधे संपर्क कर सकेंगे और WhatsApp पर ऑर्डर कर सकेंगे।",
  [LangKeys.item_marketplace_sub_inactive]: "यह प्रोडक्ट केवल आपके निजी खाते में रहेगा।",
  [LangKeys.service_marketplace_sub_active]: "यह सर्विस आसपास के ग्राहकों को ऑनलाइन दिखेगी, वे आपसे सीधे संपर्क कर सकेंगे और WhatsApp/कॉल पर बुकिंग कर सकेंगे।",
  [LangKeys.service_marketplace_sub_inactive]: "यह सर्विस केवल आपकी दुकान/फर्म के निजी खाते में रहेगी।",
  [LangKeys.item_category_lbl]: "कैटेगरी (Category)",
  [LangKeys.change_btn]: "बदलें",
  [LangKeys.item_discount_price_lbl]: "ऑफर / डिस्काउंट भाव (₹) (वैकल्पिक)",
  [LangKeys.item_discount_price_hint]: "उदा. 450",
  [LangKeys.service_discount_price_lbl]: "ऑफर / डिस्काउंट सर्विस चार्ज (₹) (वैकल्पिक)",
  [LangKeys.service_discount_price_hint]: "उदा. 750",
  [LangKeys.item_desc_lbl]: "विवरण (Short Description) (वैकल्पिक)",
  [LangKeys.item_desc_hint]: "प्रोडक्ट का ब्रांड, मॉडल, कलर, साइज व मुख्य फीचर्स लिखें (गूगल सर्च में मदद मिलेगी)...",
  [LangKeys.service_desc_lbl]: "सर्विस का विवरण (Description) (वैकल्पिक)",
  [LangKeys.service_desc_hint]: "सर्विस के मुख्य फीचर्स, कार्यप्रणाली व अनुभव लिखें (गूगल सर्च में मदद मिलेगी)...",
  [LangKeys.market_seo_badge]: "गूगल सर्च व रैंकिंग",
  [LangKeys.category_picker_title]: "कैटेगरी चुनें (Select Category)",
  [LangKeys.category_picker_sub_item]: "सामान किस श्रेणी/व्यापार का है?",
  [LangKeys.category_picker_sub_service]: "सर्विस किस श्रेणी/कार्य की है?",
  [LangKeys.category_search_hint]: "कैटेगरी खोजें (उदा. किराना, दूध, कपड़े...)",
  [LangKeys.no_category_found]: "कोई कैटेगरी नहीं मिली",
  [LangKeys.nothing_found_for]: "के लिए कुछ नहीं मिला",
  [LangKeys.cat_title_general]: "सामान्य उत्पाद",
  [LangKeys.cat_sub_general]: "General Products",
  [LangKeys.cat_title_grocery]: "किराना, राशन व प्रोविजन",
  [LangKeys.cat_sub_grocery]: "Kirana, Grocery & Provisions",
  [LangKeys.cat_title_dairy]: "डेयरी, दूध, घी व पनीर",
  [LangKeys.cat_sub_dairy]: "Dairy, Milk, Ghee & Paneer",
  [LangKeys.cat_title_fruits_veg]: "फल व ताज़ी सब्ज़ियां",
  [LangKeys.cat_sub_fruits_veg]: "Fresh Fruits & Vegetables",
  [LangKeys.cat_title_sweets_bakery]: "मिठाई, नमकीन व बेकरी",
  [LangKeys.cat_sub_sweets_bakery]: "Sweets, Snacks & Bakery",
  [LangKeys.cat_title_restaurant_food]: "होटल, ढाबा व रेस्टोरेंट",
  [LangKeys.cat_sub_restaurant_food]: "Hotel, Food & Restaurant",
  [LangKeys.cat_title_pharmacy_medical]: "मेडिकल, दवाई व हेल्थकेयर",
  [LangKeys.cat_sub_pharmacy_medical]: "Pharmacy & Healthcare",
  [LangKeys.cat_title_agriculture_seeds]: "कृषि, खाद, बीज व कीटनाशक",
  [LangKeys.cat_sub_agriculture_seeds]: "Agri, Seeds & Fertilizer",
  [LangKeys.cat_title_animal_feed]: "पशु आहार, खल, चूरी व फीड",
  [LangKeys.cat_sub_animal_feed]: "Cattle & Animal Feed",
  [LangKeys.cat_title_electronics_mobile]: "मोबाइल, लैपटॉप व कंप्यूटर",
  [LangKeys.cat_sub_electronics_mobile]: "Electronics, Mobile & IT",
  [LangKeys.cat_title_electrical_appliances]: "इलेक्ट्रिकल्स व होम अप्लायंसेज",
  [LangKeys.cat_sub_electrical_appliances]: "Electricals & Appliances",
  [LangKeys.cat_title_clothing_garments]: "कपड़े, साड़ी व रेडीमेड",
  [LangKeys.cat_sub_clothing_garments]: "Garments, Sarees & Apparel",
  [LangKeys.cat_title_footwear_shoes]: "जूते, चप्पल व फुटवियर",
  [LangKeys.cat_sub_footwear_shoes]: "Footwear & Shoes",
  [LangKeys.cat_title_hardware_sanitary]: "हार्डवेयर, सेनेटरी व टूल्स",
  [LangKeys.cat_sub_hardware_sanitary]: "Hardware, Sanitary & Tools",
  [LangKeys.cat_title_building_materials]: "बिल्डिंग मैटेरियल व सीमेंट",
  [LangKeys.cat_sub_building_materials]: "Building Materials & Cement",
  [LangKeys.cat_title_automobile_parts]: "ऑटो पार्ट्स व स्पेयर",
  [LangKeys.cat_sub_automobile_parts]: "Automobile & Spares",
  [LangKeys.cat_title_cosmetics_beauty]: "कॉस्मेटिक्स, ब्यूटी व सैलून",
  [LangKeys.cat_sub_cosmetics_beauty]: "Beauty, Salon & Cosmetics",
  [LangKeys.cat_title_stationery_books]: "किताबें, स्टेशनरी व प्रिंटिंग",
  [LangKeys.cat_sub_stationery_books]: "Books & Stationery",
  [LangKeys.cat_title_jewellery_gifts]: "सोना-चांदी व ज्वेलरी",
  [LangKeys.cat_sub_jewellery_gifts]: "Jewellery & Gifts",
  [LangKeys.cat_title_furniture_decor]: "फर्नीचर व होम डेकोर",
  [LangKeys.cat_sub_furniture_decor]: "Furniture & Home Decor",
  [LangKeys.cat_title_kitchenware_utensils]: "बर्तन व किचनवेयर",
  [LangKeys.cat_sub_kitchenware_utensils]: "Kitchenware & Utensils",
  [LangKeys.cat_title_toys_sports]: "खिलौने व स्पोर्ट्स",
  [LangKeys.cat_sub_toys_sports]: "Toys & Sports",
  [LangKeys.cat_title_packaging_disposable]: "प्लास्टिक व डिस्पोजेबल सामान",
  [LangKeys.cat_sub_packaging_disposable]: "Packaging & Disposables",
  [LangKeys.cat_title_tailoring_boutique]: "टेलरिंग व बुटीक",
  [LangKeys.cat_sub_tailoring_boutique]: "Tailoring & Boutique",
  [LangKeys.cat_title_meat_poultry]: "मीट, मछली व पोल्ट्री",
  [LangKeys.cat_sub_meat_poultry]: "Meat, Fish & Poultry",
  [LangKeys.cat_title_services_repair]: "रिपेयरिंग व मिस्त्री सर्विस",
  [LangKeys.cat_sub_services_repair]: "Repair & Services",
  [LangKeys.cat_title_other]: "अन्य सभी सामान व सेवाएं",
  [LangKeys.cat_sub_other]: "Other Products & Services",
  [LangKeys.cat_title_optical_eyewear]: "चश्मा व ऑप्टिकल्स",
  [LangKeys.cat_sub_optical_eyewear]: "Optical & Eyewear",
  [LangKeys.cat_title_pooja_religious]: "पूजा सामग्री व अगरबत्ती",
  [LangKeys.cat_sub_pooja_religious]: "Pooja Items & Essentials",
  [LangKeys.cat_title_watches_accessories]: "घड़ी व एक्सेसरीज",
  [LangKeys.cat_sub_watches_accessories]: "Watches & Accessories",
  [LangKeys.cat_title_generalservice]: "सामान्य सेवा (General Service)",
  [LangKeys.cat_sub_generalservice]: "All General Services & Labor",
  [LangKeys.cat_title_electronics_tv_repair]: "टीवी, LED व इलेक्ट्रॉनिक्स रिपेयरिंग",
  [LangKeys.cat_sub_electronics_tv_repair]: "TV, LED, Music System & Electronics",
  [LangKeys.cat_title_ac_appliances_repair]: "एसी, फ्रिज, वाशिंग मशीन व गीजर",
  [LangKeys.cat_sub_ac_appliances_repair]: "AC, Refrigerator & Home Appliances",
  [LangKeys.cat_title_electrician_wiring]: "इलेक्ट्रीशियन, वायरिंग व पंखे",
  [LangKeys.cat_sub_electrician_wiring]: "Electrician, Fitting & Rewinding",
  [LangKeys.cat_title_plumbing_sanitary]: "प्लंबर, पाइप व सेनेटरी फिटिंग",
  [LangKeys.cat_sub_plumbing_sanitary]: "Plumber & Sanitary Fitting",
  [LangKeys.cat_title_tailoring_stitching]: "सिलाई, टेलरिंग व बुटीक",
  [LangKeys.cat_sub_tailoring_stitching]: "Tailoring, Stitching & Boutique",
  [LangKeys.cat_title_mobile_laptop_repair]: "मोबाइल, लैपटॉप व कंप्यूटर रिपेयर",
  [LangKeys.cat_sub_mobile_laptop_repair]: "Mobile, Laptop & Desktop Service",
  [LangKeys.cat_title_automobile_mechanic]: "कार, बाइक, ऑटो सर्विस व वॉशिंग",
  [LangKeys.cat_sub_automobile_mechanic]: "Car, Bike & Auto Mechanic / Washing",
  [LangKeys.cat_title_beauty_parlour_salon]: "ब्यूटी पार्लर, सैलून व मेकओवर",
  [LangKeys.cat_sub_beauty_parlour_salon]: "Beauty Parlour, Salon & Bridal",
  [LangKeys.cat_title_carpenter_woodwork]: "बढ़ई / कारपेंटर व लकड़ी काम",
  [LangKeys.cat_sub_carpenter_woodwork]: "Carpenter, Furniture & Woodwork",
  [LangKeys.cat_title_painting_whitewash]: "पेंटिंग, पुट्टी व वाइटवॉश",
  [LangKeys.cat_sub_painting_whitewash]: "Wall Painting, Putty & Polish",
  [LangKeys.cat_title_construction_civil]: "मकान निर्माण, ठेकेदार व मिस्त्री",
  [LangKeys.cat_sub_construction_civil]: "Civil Contractor, Mason & Labour",
  [LangKeys.cat_title_agri_motor_tractor]: "ट्रैक्टर, ट्यूबवेल व मोटर सर्विस",
  [LangKeys.cat_sub_agri_motor_tractor]: "Tractor, Water Pump & Agri Motors",
  [LangKeys.cat_title_cctv_security_install]: "सीसीटीवी व सिक्योरिटी इंस्टॉलेशन",
  [LangKeys.cat_sub_cctv_security_install]: "CCTV Camera & Security Fitting",
  [LangKeys.cat_title_cleaning_pest_control]: "क्लीनिंग, वाटर टैंक व पेस्ट कंट्रोल",
  [LangKeys.cat_sub_cleaning_pest_control]: "Deep Cleaning, Water Tank & Pest",
  [LangKeys.cat_title_transport_loading]: "ट्रांसपोर्ट, लोडिंग व पिकअप",
  [LangKeys.cat_sub_transport_loading]: "Transport, Loading & Movers",
  [LangKeys.cat_title_photography_video]: "फोटोग्राफी व वीडियोग्राफी",
  [LangKeys.cat_sub_photography_video]: "Photo, Video & Studio Services",
  [LangKeys.cat_title_events_catering_tent]: "टेंट हाउस, कैटरिंग, DJ व साउंड",
  [LangKeys.cat_sub_events_catering_tent]: "Tent, Catering, DJ & Events",
  [LangKeys.cat_title_education_tuition]: "कोचिंग, ट्यूशन व क्लासेज",
  [LangKeys.cat_sub_education_tuition]: "Tuition & Education Classes",
  [LangKeys.cat_title_ca_tax_csc_emitra]: "सीए, टैक्स, CSC व ई-मित्र सेवा",
  [LangKeys.cat_sub_ca_tax_csc_emitra]: "CA, Tax, CSC, E-Mitra & Online Forms",
  [LangKeys.cat_title_healthcare_clinic_lab]: "डॉक्टर, क्लिनिक, नर्सिंग व लैब टेस्ट",
  [LangKeys.cat_sub_healthcare_clinic_lab]: "Doctor, Nursing & Diagnostics",
  [LangKeys.cat_title_other_service]: "अन्य सभी सेवाएं व कारीगरी",
  [LangKeys.cat_sub_other_service]: "Other Services & Skilled Work",
  [LangKeys.cat_title_transport_taxi]: "टैक्सी व टूर ट्रैवल्स",
  [LangKeys.cat_sub_transport_taxi]: "Taxi & Tour Travels",
  [LangKeys.cat_title_legal_advocate]: "वकील व कानूनी सलाह",
  [LangKeys.cat_sub_legal_advocate]: "Legal & Advocate Services",
  [LangKeys.cat_title_packers_movers]: "पैकर्स एंड मूवर्स",
  [LangKeys.cat_sub_packers_movers]: "Packers & Movers",
  [LangKeys.cat_title_printing_flex_banner]: "प्रिंटिंग व फ्लैक्स बोर्ड",
  [LangKeys.cat_sub_printing_flex_banner]: "Printing & Flex Banner",
  [LangKeys.cat_title_gym_fitness_yoga]: "जिम, फिटनेस व योग",
  [LangKeys.cat_sub_gym_fitness_yoga]: "Gym, Fitness & Yoga",
  [LangKeys.cat_title_cook_maid_househelp]: "कुक व घरेलू सहायिका",
  [LangKeys.cat_sub_cook_maid_househelp]: "Cook & Domestic Help",
  [LangKeys.item_photo_guide_verified]: "फ़ोटो जोड़ी गई • Tier-1 टॉप लिस्टिंग",
  [LangKeys.item_photo_guide_why_add]: "फ़ोटो क्यों जोड़ें? (5x अधिक बिक्री)",
  [LangKeys.service_photo_guide_why_add]: "फ़ोटो क्यों जोड़ें? (5x अधिक बुकिंग)",
  [LangKeys.item_photo_guide_desc]: "साफ़ रोशनी व बिना धुंधली PNG/JPG फ़ोटो लगाएं। बिना फ़ोटो की तुलना में फ़ोटो वाले प्रॉडक्ट्स ऑनलाइन बाज़ार में सबसे ऊपर दिखते हैं।",
  [LangKeys.service_photo_guide_desc]: "अपने काम, वर्कशॉप या दुकान की साफ़ PNG/JPG फ़ोटो लगाएं। बिना फ़ोटो की तुलना में फ़ोटो वाली सेवाएं नज़दीकी ग्राहकों को सबसे ऊपर दिखती हैं।",
  [LangKeys.item_video_guide_btn_title]: "ऑनलाइन लिस्टिंग सीखें (5 मिनट वीडियो)",
  [LangKeys.service_video_guide_btn_title]: "सर्विस लिस्टिंग सीखें (5 मिनट वीडियो)",
  [LangKeys.market_format_bold]: "𝗕 बोल्ड (*नाम*)",
  [LangKeys.market_format_bullet]: "• बुलेट पॉइंट",
  [LangKeys.market_format_highlight]: "⭐ मुख्य खासियत",
  [LangKeys.market_format_warranty_item]: "📦 वारंटी / विवरण",
  [LangKeys.market_format_warranty_service]: "📦 वारंटी / गारंटी",
  [LangKeys.market_format_template_item]: "⚡ तैयार ब्लॉग टेम्पलेट",
  [LangKeys.market_format_template_service]: "⚡ तैयार सर्विस टेम्पलेट",
  [LangKeys.market_seo_tip_item]: "विस्तृत विवरण लिखने से आपका प्रोडक्ट गूगल सर्च व ऑनलाइन मार्केट में तेज़ी से ग्राहकों को दिखेगा।",
  [LangKeys.market_seo_tip_service]: "विस्तृत विवरण लिखने से आपकी सर्विस गूगल सर्च व ऑनलाइन मार्केट में तेज़ी से ग्राहकों को दिखेगी।",
  [LangKeys.crop_photo_title]: "फोटो क्रॉप और एडजस्ट करें",
  [LangKeys.crop_product_photo]: "प्रोडक्ट फोटो क्रॉप और एडजस्ट करें",
  [LangKeys.crop_service_photo]: "सर्विस फोटो क्रॉप और एडजस्ट करें",
  [LangKeys.crop_drag_hint]: "उंगली या माउस से फोटो को हिलाएं / ड्रैग करें",
  [LangKeys.crop_rotate_left]: "90° बाएँ",
  [LangKeys.crop_rotate_right]: "90° दाएँ",
  [LangKeys.crop_reset]: "रीसेट",
  [LangKeys.crop_ratio_square]: "1:1 (वर्गाकार)",
  [LangKeys.crop_ratio_standard]: "4:3 (मानक)",
  [LangKeys.crop_ratio_free]: "Free (मुक्त)",
  [LangKeys.crop_save_done]: "क्रॉप व सेव करें (Done)",
  [LangKeys.crop_compressing]: "कंप्रेस हो रहा है...",
  [LangKeys.party_or_details]: "पार्टी / विवरण",
  [LangKeys.report_copied_clipboard]: "रिपोर्ट का विवरण क्लिपबोर्ड पर कॉपी हो गया है!",
  [LangKeys.party]: "पार्टी",
  [LangKeys.sale]: "बिक्री",
  [LangKeys.purchase]: "खरीद",
  [LangKeys.expense]: "खर्च",
  [LangKeys.ai_support_btn]: "AI सहायता से तुरंत चैट करें (24x7 Live)",
  [LangKeys.ai_support_title]: "Moxpal AI सपोर्ट",
  [LangKeys.ai_support_online_status]: "● 24x7 तत्काल सहायता",
  [LangKeys.ai_support_welcome_msg]: "नमस्ते! 🙏 मैं *Moxpal Khata* का स्मार्ट AI सहायक हूँ।\\n\\nमैं आपके खाते, बिलिंग, डेयरी पासबुक या सब्सक्रिप्शन प्लान से जुड़े सभी सवालों में आपकी मदद के लिए तैयार हूँ। आप क्या जानना चाहते हैं?",
  [LangKeys.ai_support_input_hint]: "अपना सवाल या समस्या यहाँ पूछें...",
  [LangKeys.ai_support_typing]: "AI सहायक उत्तर लिख रहा है...",
  [LangKeys.ai_support_copied]: "संदेश कॉपी कर लिया गया",
  [LangKeys.ai_support_net_error]: "इंटरनेट कनेक्शन में समस्या आ रही है। कृपया अपना नेटवर्क चेक करें या दोबारा भेजें।",
  [LangKeys.ai_support_server_error]: "सर्वर से जुड़ने में समस्या हुई। कृपया पुनः प्रयास करें या हमारी हेल्पलाइन +91 9929371541 पर WhatsApp संपर्क करें।",
  [LangKeys.ai_support_sugg_plan]: "💎 प्लान के क्या-क्या फायदे हैं?",
  [LangKeys.ai_support_sugg_dairy]: "🥛 डेयरी पासबुक कैसे इस्तेमाल करें?",
  [LangKeys.ai_support_sugg_party]: "👥 नया ग्राहक/खाता कैसे जोड़ें?",
  [LangKeys.ai_support_sugg_backup]: "💾 डेटा बैकअप कैसे लें?",
  [LangKeys.ai_support_sugg_bill]: "🧾 नया बिल या इनवॉइस कैसे बनाएं?",
  [LangKeys.ai_support_clear_chat]: "नई बातचीत शुरू करें",
  [LangKeys.ai_support_clear_title]: "चैट इतिहास हटाएं?",
  [LangKeys.ai_support_clear_confirm]: "क्या आप पुरानी बातचीत हटाकर नई चैट शुरू करना चाहते हैं?",
  [LangKeys.help_center_title]: "Moxpal Khata Help Center",
  [LangKeys.help_center_sub]: "अक्सर पूछे जाने वाले सवाल, ट्यूटोरियल और कस्टमर सपोर्ट का वन-स्टॉप केंद्र",
  [LangKeys.help_support_title]: "हेल्प और सपोर्ट",
  [LangKeys.help_center_heading]: "Moxpal Khata Help Center",
  [LangKeys.help_center_subheading]: "FAQs, ट्यूटोरियल और कस्टमर सपोर्ट के लिए आपका वन-स्टॉप सेंटर",
  [LangKeys.help_ai_title]: "Moxpal AI Support",
  [LangKeys.help_ai_live_badge]: "24x7 LIVE",
  [LangKeys.help_ai_online_status]: "• 24x7 त्वरित सहायता",
  [LangKeys.help_ai_desc]: "खाता, बिलिंग, इन्वेंटरी, डेयरी पासबुक या प्लान से जुड़े सभी सवालों का तत्काल AI समाधान पाएं।",
  [LangKeys.help_ai_chat_btn]: "Chat with AI Support (24x7 Live)",
  [LangKeys.help_whatsapp_title]: "Contact Us (WhatsApp)",
  [LangKeys.help_whatsapp_sub]: "+91 99293 71541 • आधिकारिक सपोर्ट टीम",
  [LangKeys.help_call_title]: "कॉल हेल्पलाइन",
  [LangKeys.help_call_number]: "+91 9166277283",
  [LangKeys.help_email_title]: "ईमेल सपोर्ट",
  [LangKeys.help_email_id]: "support@moxpal.com",
  [LangKeys.help_faq_title]: "अक्सर पूछे जाने वाले सवाल (FAQs)",
  [LangKeys.help_faq_1_q]: "खाता में नया ग्राहक या सप्लायर कैसे जोड़ें?",
  [LangKeys.help_faq_1_a]: "होम स्क्रीन पर \"Add Customer\" बटन दबाएं, नाम और मोबाइल नंबर दर्ज करें और सुरक्षित करें।",
  [LangKeys.help_faq_2_q]: "डेयरी पासबुक में दूध कलेक्शन कैसे करें?",
  [LangKeys.help_faq_2_a]: "डेयरी सेक्शन में जाकर \"दूध एंट्री\" चुनें, फैट/SNF या सीधे रेट दर्ज करके 1-क्लिक में रसीद भेजें।",
  [LangKeys.help_faq_3_q]: "डेटा बैकअप कैसे सुरक्षित रहता है?",
  [LangKeys.help_faq_3_a]: "मोक्षपाल खाता पर आपका समस्त डेटा क्लाउड सर्वर पर 100% एन्क्रिप्टेड और सुरक्षित रहता है।",
  [LangKeys.help_faq_4_q]: "सब्सक्रिप्शन प्लान कैसे अपग्रेड करें?",
  [LangKeys.help_faq_4_a]: "सेटिंग्स में जाकर \"मेरी सदस्यता\" पर जाएं और अपनी पसंद का प्लान चुनकर सुरक्षित पेमेंट करें।",
  [LangKeys.help_footer_call_hours]: "कॉल सपोर्ट: सोम - शनि (सुबह 9:00 से रात 8:00)",
  [LangKeys.help_footer_ai_hours]: "AI चैट सहायक: 24 घंटे 365 दिन तत्काल सहायता",
  [LangKeys.help_footer_branding]: "Moxpal Technologies • 100% सुरक्षित एवं विश्वसनीय • Made in India 🇮🇳",
  [LangKeys.help_feature_launch_error]: "सुविधा खोलने में असमर्थ",
};

export default hi;